import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  manageAndTrackYourContractors: "Manage and track your contractors",
  totalContractors: "Total Contractors",
  activeContractors: "Active Contractors",
  thisMonth: "This Month",
  searchContractors: "Search contractors...",
  noResultsFound: "No Results Found",
  tryDifferentSearchTerm: "Try a different search term",
  inviteYourFirstContractor: "Invite Your First Contractor",
  loading: "Loading...",
  contractor: "Contractor",
  contractorAccount: "Contractor Account",
  back: "Back",
  dashboard: "Dashboard",
  employees: "Employees",
  expenses: "Expenses",

  failedToLoadAvailableContractors: "Failed to load available contractors",
  inviteSentSuccessfully: "Invite sent successfully",
  failedToSendInvite: "Failed to send invite",
  unnamed: "Unnamed",
  id: "ID",
  pending: "Pending",
  invite: "Invite",
  inviteContractors: "Invite Contractors",
  searchById: "Search by ID...",
  loading: "Loading...",
  enterIdToSearch: "Enter ID to search for contractors",
  noContractorsFound: "No contractors found",

  home: "Home",
  settings: "Settings",
  user: "User",
  accountantAccount: "Accountant Account",
  logout: "Logout",
  dashboard: "Dashboard",

  unknown: "Unknown",
  noData: "No Data",
  noInvoicesToExport: "No invoices to export",
  invoiceNumber: "Invoice Number",
  vendorName: "Vendor Name",
  businessNumber: "Business Number",
  invoiceDate: "Invoice Date",
  place: "Place",
  subTotal: "Sub Total",
  taxRate: "Tax Rate",
  taxAmount: "Tax Amount",
  totalAmount: "Total Amount",
  totals: "Totals",
  success: "Success",
  exportedSuccessfully: "Exported successfully",
  error: "Error",
  exportFailed: "Export failed",
  invoices: "Invoices",
  date: "Date",
  tax: "Tax",
  generatedBy: "Generated by",
  printDialogOpened: "Print dialog opened. Choose 'Save as PDF' to save.",
  amount: "Amount",
  withInvoice: "With Invoice",
  yes: "Yes",
  no: "No",
  note: "Note",
  invoiceDetails: "Invoice Details",
  expenseDetails: "Expense Details",
  expensesAndInvoices: "Expenses & Invoices",
  totalExpenses: "Total Expenses",
  items: "Items",
  outOf: "out of",
  noInvoice: "No Invoice",
  needsAttention: "Needs Attention",
  totalSubTotal: "Total Sub Total",
  totalTax: "Total Tax",
  fromInvoices: "From Invoices",
  totalInvoices: "Total Invoices",
  expenses: "Expenses",
  searchInvoices: "Search invoices...",
  cancel: "Cancel",
  select: "Select",
  deselectAll: "Deselect All",
  selectAll: "Select All",
  export: "Export",
  exportAll: "Export All",
  noExpensesFound: "No Expenses Found",
  expensesWillAppearHere: "Expenses will appear here",
  noSearchResults: "No Search Results",
  noInvoicesFound: "No Invoices Found",
  tryDifferentSearch: "Try a different search term",
  invoicesWillAppearHere: "Invoices will appear here",
  ok: "OK",
  exportOptions: "Export Options",
  chooseExportFormat: "Choose export format",
  excelDescription: "Export as spreadsheet for data analysis",
  pdfDescription: "Export as formatted document for printing",
  total: "Total",
  place: "Place",
  me: "Me",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  workSlip: "Work Slip",
  contractor: "Contractor",
  employeeName: "Employee Name",
  salaryType: "Salary Type",
  monthlySalary: "Monthly Salary",
  dailySalary: "Daily Salary",
  employeeInformation: "Employee Information",
  summary: "Summary",
  workingDays: "Working Days",
  totalSalaryMonth: "Total Salary (Month)",
  avgPerDay: "Avg per Day",
  avgDaily: "Avg Daily",
  workDays: "Work Days",
  day: "Day",
  dayName: "Day Name",
  salary: "Salary",
  manager: "Manager",
  notes: "Notes",
  worked: "Worked",
  noWorkDataForMonth: "No work data for this month",
  generatedOn: "Generated on",
  selectMonth: "Select Month",
  excelExportedSuccessfully: "Excel exported successfully",
  failedToExportExcel: "Failed to export Excel",
  pleaseSelectMonth: "Please select a month first",
  exportWorkSlip: "Export Work Slip",
  chooseExportFormat: "Choose export format",
  excelDescription: "Export as spreadsheet for data analysis",
  pdfDescription: "Export as formatted document for printing",
  monthly: "Monthly",
  daily: "Daily",

  monthly: "Monthly",
  daily: "Daily",
  manager: "Manager",
  employee: "Employee",
  employees: "Employees",
  managers: "Managers",
  id: "ID",
  contractor: "Contractor",
  searchByName: "Search by name...",
  noEmployeesMatchSearch: "No employees match your search",
  noEmployeesFound: "No employees found",
  tryDifferentSearch: "Try a different search term",
  pullDownToRefresh: "Pull down to refresh",

  failedToLoadContractors: "Failed to load contractors",
  phoneNumberNotAvailable: "Phone number not available",
  emailNotAvailable: "Email not available",
  active: "Active",
  noContactInfo: "No contact info",
  id: "ID",
  loadingContractors: "Loading contractors...",
  myContractors: "My Contractors",
  contractors: "contractors",
  inviteContractor: "Invite Contractor",
  activeContractors: "Active Contractors",
  noContractorsFound: "No Contractors Found",
  contractorsWillAppearHere: "Contractors will appear here",

  settings: "Settings",
  manageYourPreferences: "Manage your preferences",
  language: "Language",
  change: "Change",
  selectLanguage: "Select Language",
  chooseYourPreferredLanguage: "Choose your preferred language",

  // Language names
  languageEnglish: "English",
  languageArabic: "Arabic",
  languageHebrew: "Hebrew",
  Contact: "Contact",
  GetInTouch: "Get In Touch",
  ContactDescription: "Have questions? We're here to help!",
  WhatsApp: "WhatsApp",
  ChatWithUs: "Chat with us",
  Phone: "Phone",
  CallUs: "Call us directly",
  SMS: "SMS",
  TextUs: "Send us a text",
  ContactAvailability: "Available 24/7 to assist you",
  // Navigation
  Features: "Features",
  MobileApp: "Mobile App",
  Benefits: "Benefits",
  GetStarted: "Get Started",

  // Hero Section
  TrustedByProfessionals: "🚀 Trusted by 10,000+ professionals",
  AppointmentManagement: "Appointment Management,",
  Simplified: "Simplified",
  HeroDescription:
    "Transform your scheduling chaos into seamless operations. NeholEsek brings together powerful booking tools, client management, and analytics in one beautiful platform.",
  StartFreeTrial: "Start Free Trial",
  WatchDemo: "Watch Demo",

  // Stats
  ActiveUsers: "Active Users",
  AppointmentsBooked: "Appointments Booked",
  Uptime: "Uptime",
  UserRating: "User Rating",

  // Features Section
  EverythingYouNeedTo: "Everything You Need to",
  Succeed: "Succeed",
  BuiltForProfessionals:
    "Built for professionals who demand excellence in every detail",

  SmartScheduling: "Smart Scheduling",
  SmartSchedulingDesc:
    "Intelligent appointment management that adapts to your workflow and eliminates double bookings",
  SmartSchedulingStat: "99.8% accuracy",

  ClientManagement: "Client Management",
  ClientManagementDesc:
    "Comprehensive client profiles with history, preferences, and automated communication",
  ClientManagementStat: "50% time saved",

  AnalyticsInsights: "Analytics & Insights",
  AnalyticsInsightsDesc:
    "Real-time statistics and predictive analytics to optimize your business performance",
  AnalyticsInsightsStat: "3x growth",

  // Mobile App Section
  AvailableOnMobile: "Available on Mobile",
  ManageEverything: "Manage Everything",
  OnTheGo: "On the Go",
  MobileAppDescription:
    "Download the NeholEsek mobile app and take control of your appointments from anywhere",

  YourBusinessInYourPocket: "Your Business in Your Pocket",
  MobileAppFullDescription:
    "The NeholEsek mobile app gives you complete control over your appointments, clients, and business analytics—right from your smartphone.",

  RealTimeSync: "Real-time Sync",
  RealTimeSyncDesc: "Instant updates across all your devices",

  PushNotifications: "Push Notifications",
  PushNotificationsDesc: "Never miss an appointment or message",

  WorksOffline: "Works Offline",
  WorksOfflineDesc: "Access your data even without internet",

  DownloadNow: "Download Now",
  GetItOnGooglePlay: "GET IT ON",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "Download on the",
  AppStore: "App Store",

  FreeToDownload: "✨ Free to download • Available worldwide • Regular updates",

  SeeItInAction: "See It in Action",

  // Benefits Section
  WhyProfessionalsChoose: "Why Professionals Choose",
  NeholEsek: "NeholEsek",
  BenefitsDescription:
    "Join thousands of businesses who've transformed their operations with intelligent appointment management.",

  SaveHoursDaily: "Save Hours Daily",
  SaveHoursDesc: "Automate repetitive tasks and focus on what matters",

  NeverMissAppointment: "Never Miss an Appointment",
  NeverMissDesc: "Automated reminders and smart notifications",

  InstantSetup: "Instant Setup",
  InstantSetupDesc: "Get started in under 5 minutes",

  BoostRevenue: "Boost Revenue",
  BoostRevenueDesc: "Reduce no-shows by 67% with smart reminders",

  TodaysAppointments: "Today's Appointments",
  ClientSatisfaction: "Client Satisfaction",
  ThisMonthRevenue: "This Month's Revenue",
  PercentageFromLastMonth: "+23% from last month",
  ActiveClients: "Active Clients",
  ShowRate: "Show Rate",

  // CTA Section
  ReadyToTransform: "Ready to Transform Your Business?",
  CTADescription:
    "Join 10,000+ professionals who trust NeholEsek for their scheduling needs",
  DownloadApp: "Download App",
  FreeTrial: "No credit card required • 45-day free trial • Cancel anytime",

  // Footer
  Privacy: "Privacy",
  Terms: "Terms",
  Contact: "Contact",
  CopyrightMainPage: "© 2024 NeholEsek. All rights reserved.",
  CustomerReviews: "Customer Reviews",
  SeeWhatOurCustomersSay: "See what our customers say about us",
  OutOf: "out of",
  Reviews: "reviews",
  NoComment: "No comment provided",
  TheMainPage: "Main Page",
  Gallery: "Gallery",
  myappointments: "My Appointments",
  ContactInfo: "Contact Info",
  Chooselanguage: "Choose language",
  Home: "Home",
  MyAppointments: "My Appointments",
  Loading: "Loading...",
  BookYourAppointment: "Book Your Appointment",
  ChoosePreferredDateTime: "Choose your preferred date and time",
  OnlineBookingComingSoon: "Online Booking Coming Soon",
  BarberStopDescription:
    "BarberStop allows scheduling appointments through the app! Currently, this feature is being set up.",
  InTheMeantime: "In the meantime, book your appointment via:",
  SMS: "SMS",
  PhoneCall: "Phone Call",
  WhatsApp: "WhatsApp",
  Tip: "Tip:",
  MentionBarberStop: 'Mention "BarberStop" when you reach out!',
  ModernBookingSolutions: "Modern Booking Solutions",
  Copyright: "© 2025 NeholEsek. All rights reserved.",

  // New Business Owner translations
  ForBusinessOwners: "For Business Owners",
  WantYourOwnBusinessApp: "Want Your Own Business?",
  DownloadNeholEsekForBusinessOwners:
    "Download NeholEsek and start managing your barber shop today!",
  Business: "Business",
  WhatsIncluded: "What's Included:",
  ManageAppointments: "Manage appointments online",
  TrackCustomers: "Track your customers",
  IncreaseRevenue: "Increase your revenue",
  BusinessAnalytics: "Business analytics & reports",
  JoinThousandsOfBarbers:
    "Join thousands of barbers managing their business with NeholEsek",
  DownloadOnThe: "Download on the",
  GetItOn: "GET IT ON",

  // MPHomeApps translations
  PleaseLoginToView: "Please log in to view your appointments",
  SignInToAccess:
    "Sign in to access your appointment history and manage bookings",
  LoadingYourAppointments: "Loading your appointments...",
  ManageYourBookings: "Manage your upcoming bookings",
  User: "User",
  Logout: "Logout",
  NoAppointmentsYet: "No appointments yet",
  BookYourFirst: "Book your first appointment to get started with our services",
  TodaysAppointment: "Today's Appointment",
  Past: "Past",
  Min: "min",
  Services: "Services",
  Total: "Total",
  Barber: "Barber:",
  CancelAppointment: "Cancel Appointment",
  CancelAppointmentQuestion: "Cancel Appointment?",
  CancelConfirmation:
    "Are you sure you want to cancel this appointment? This action cannot be undone.",
  KeepIt: "Keep It",
  YesCancel: "Yes, Cancel",

  // MPHomeBookApp translations
  Login: "Login",
  BarberStep: "Barber",
  ServicesStep: "Services",
  Book: "Book",
  ChooseYourBarber: "Choose Your Barber",
  SelectBarberForAppointment: "Select a barber for your appointment",
  ProfessionalBarber: "Professional Barber",
  SelectABarber: "Select a barber",
  ChoosePreferredBarber: "Choose your preferred barber to continue",
  NextSelectServices: "Next: Select Services →",
  YourBarber: "Your barber",
  Change: "Change",
  SelectYourServices: "Select Your Services",
  ChooseOneOrMoreServices: "Choose one or more services for your appointment",
  TotalDuration: "Total Duration",
  TotalPrice: "Total Price",
  SelectAtLeastOneService: "Select at least one service",
  ChooseFromServices: "Choose from our services above to continue",
  NextSelectDateTime: "Next: Select Date & Time →",
  SelectedServices: "SELECTED SERVICES",
  Edit: "Edit",
  SelectDate: "Select Date",
  Today: "Today",
  AvailableTimes: "Available Times",
  TotalDurationNeeded: "Total Duration Needed:",
  Minutes: "minutes",
  ShowingConsecutiveSlots: "Showing times with enough consecutive slots",
  NoAvailableAppointments: "No available appointments",
  NoConsecutiveSlotsFound:
    "No consecutive slots found with {duration} minutes available. Try selecting another date or fewer services.",
  PleaseSelectAnotherDate: "Please select another date",
  BackToServices: "← Back to Services",

  // MPHomeLoginWithPhoneNumber translations
  Phone: "Phone",
  Verify: "Verify",
  Name: "Name",
  Welcome: "Welcome! 👋",
  EnterPhoneToGetStarted: "Enter your phone number to get started",
  PhoneNumber: "Phone Number",
  FullNumber: "Full Number:",
  Sending: "Sending...",
  SendVerificationCode: "Send Verification Code",
  VerifyYourNumber: "Verify Your Number 🔐",
  WeSentCodeTo: "We sent a code to",
  VerificationCode: "Verification Code",
  EnterSixDigitCode: "Enter 6-digit code",
  Verifying: "Verifying...",
  VerifyCode: "Verify Code",
  ChangePhoneNumber: "← Change Phone Number",
  AlmostThere: "Almost There! ✨",
  EnterNameToComplete: "Please enter your name to complete registration",
  YourName: "Your Name",
  EnterFullName: "Enter your full name",
  Completing: "Completing...",
  CompleteRegistration: "Complete Registration",
  PleaseEnterValidPhone: "Please enter a valid phone number",
  OTPSentTo: "OTP sent to",
  ErrorMessage: "Error:",
  PhoneVerifiedSuccessfully: "Phone verified successfully!",
  PleaseEnterValidOTP: "Please enter a valid 6-digit OTP",
  InvalidOTP: "Invalid OTP. Please try again.",
  PleaseEnterYourName: "Please enter your name",
  LoginSuccessful: "Login successful!",
  FailedToSaveUser: "Failed to save user:",

  // MPHomeModalMakeApp translations
  ConfirmYourBooking: "Confirm Your Booking",
  ReviewAppointmentDetails: "Review your appointment details below",
  YourInformation: "YOUR INFORMATION",
  Guest: "Guest",
  NotAvailable: "N/A",
  BarberDetails: "BARBER DETAILS",
  AppointmentDetails: "APPOINTMENT DETAILS",
  Date: "Date",
  Time: "Time",
  Duration: "Duration",
  SelectedServicesUpper: "SELECTED SERVICES",
  Cancel: "Cancel",
  BookingInProgress: "Booking...",
  ConfirmBooking: "Confirm Booking",
  ConfirmationMessage: "Confirmation Message",
  WhatsAppConfirmation: "You'll receive a WhatsApp confirmation shortly",

  // Contractor Landing Page
  signIn: "Sign In",
  demo: "Demo",
  pricing: "Pricing",
  availableOnMobileWeb: "📱 Available on Mobile & Web",
  heroTitleContractor: "Manage Your Construction Business Like a",
  heroPro: "Pro",
  heroDescriptionContractor:
    "Complete workforce management solution for contractors. Track employees, manage salaries, monitor profits, and control expenses all in one powerful platform.",
  getStartedFree: "Get Started Free",
  noCreditCardRequired: "No credit card required",
  fortyFiveDayFreeTrial: "45-day free trial",
  todaysOverview: "Today's Overview",
  liveLabel: "Live",
  activeEmployees: "Active Employees",
  monthlyProfit: "Monthly Profit",
  activeSites: "Active Sites",
  growthRate: "Growth Rate",
  revenueVsExpenses: "Revenue vs Expenses",
  everythingYouNeedToSucceed: "Everything You Need to Succeed",
  powerfulFeaturesForContractors:
    "Powerful features designed for modern contractors",
  featureEmployeeManagement: "Employee Management",
  featureEmployeeManagementDesc:
    "Track daily attendance, work hours, and assign employees to specific job sites effortlessly",
  featureSalaryPayroll: "Salary & Payroll",
  featureSalaryPayrollDesc:
    "Automated salary calculations based on work days and hours with detailed payment records",
  featureProfitAnalytics: "Profit Analytics",
  featureProfitAnalyticsDesc:
    "Real-time profit tracking with comprehensive financial reports and expense management",
  featureRoleBasedAccess: "Role-Based Access",
  featureRoleBasedAccessDesc:
    "Hierarchical system: Contractor → Managers → Users with customizable permissions",
  featureJobSiteTracking: "Job Site Tracking",
  featureJobSiteTrackingDesc:
    "Create and manage multiple workplaces, assign teams, and monitor progress daily",
  featureExpenseControl: "Expense Control",
  featureExpenseControlDesc:
    "Track all project expenses with approval workflows and budget monitoring",
  hierarchicalAccessControl: "Hierarchical Access Control",
  completeControlWhoSeesWhat: "Complete control over who sees what",
  fullAccessToEverything: "Full access to everything",
  createWorkplaces: "Create workplaces",
  manageAllEmployees: "Manage all employees",
  createManagerAccounts: "Create manager accounts",
  setPermissionsAccess: "Set permissions & access",
  viewAllFinancialData: "View all financial data",
  assignedSiteAccess: "Assigned site access",
  accessAssignedSites: "Access assigned sites",
  enterDailyAttendance: "Enter daily attendance",
  createUserAccounts: "Create user accounts",
  submitExpensesIfAllowed: "Submit expenses (if allowed)",
  viewPermittedData: "View permitted data",
  limitedAccess: "Limited access",
  viewAssignedTasks: "View assigned tasks",
  checkInOutOfSites: "Check-in/out of sites",
  viewOwnWorkHistory: "View own work history",
  accessBasicReports: "Access basic reports",
  submitTimesheets: "Submit timesheets",
  realTimeDataVisualization: "Real-time data visualization and management",
  daysWorked: "Days Worked",
  statusLabel: "Status",
  jobSitePerformance: "Job Site Performance",
  siteName: "Site Name",
  revenueLabel: "Revenue",
  profitLabel: "Profit",
  powerfulAnalyticsDashboard: "Powerful Analytics Dashboard",
  trackBusinessPerformance:
    "Track your business performance with beautiful visualizations",
  totalRevenue: "Total Revenue",
  netProfit: "Net Profit",
  activeProjects: "Active Projects",
  last6Months: "Last 6 Months",
  expenseBreakdown: "Expense Breakdown",
  projectCompletion: "Project Completion",
  performanceMetrics: "Performance Metrics",
  efficiencyRate: "Efficiency Rate",
  onTimeDelivery: "On-Time Delivery",
  ctaDescriptionContractors:
    "Join hundreds of contractors who've streamlined their operations with ContractorPro",
  scheduleDemo: "Schedule Demo",
  noCreditCardFreeTrialCancel:
    "No credit card required • 45-day free trial • Cancel anytime",
  footerDescription:
    "The complete solution for modern contractors to manage their workforce and finances.",
  footerProduct: "Product",
  footerCompany: "Company",
  footerLegal: "Legal",
  aboutUs: "About Us",
  careers: "Careers",
  blog: "Blog",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  securityLabel: "Security",
  faq: "FAQ",

  // BossMainPage Navigation
  places: "Places",
  general: "General",
  calc: "Calc",
  createInvoice: "Create Invoice",
  createOffer: "Create Offer",
  ownerAccount: "Owner Account",
  workforce: "Workforce",
  myEmployees: "My Employees",
  contactUs: "Contact Us",
  accountant: "Accountant",
  deleteAccount: "Delete Account",

  // Calculator
  projectCalculator: "Project Calculator",
  smallProject: "Small Project",
  bigProject: "Big Project",
  oneTimeFixedPriceEstimate: "One-time fixed price estimate",
  monthByMonthBilling: "Month-by-month, progress-based billing",

  // Employee Management
  createEmployee: "Create Employee",
  createNewEmployee: "Create New Employee",
  addNewTeamMember: "Add a new team member",
  updateEmployee: "Update Employee",
  updateProfile: "Update Profile",
  employeeType: "Employee Type",
  employeeId: "Employee ID",
  employeeStatus: "Employee Status",
  inactive: "Inactive",
  inactiveEmployees: "Inactive Employees",
  inactivePlaces: "Inactive Places",
  noInactiveEmployees: "No Inactive Employees",
  noInactivePlaces: "No Inactive Places",
  allEmployeesActive: "All employees are currently active",
  allPlacesActive: "All places are active",
  noEmployeesYet: "No Employees Yet",
  tapButtonToAddFirstMember: "Tap the + button to add your first team member.",
  nothingMatchesSearch: "Nothing matches your search. Try a different term.",
  employeeTypeDesc:
    "Employees have standard access to their assigned tasks and work areas.",
  managerTypeDesc:
    "Managers have elevated permissions including team oversight and reporting capabilities.",

  // Place Management
  createPlace: "Create Place",
  createNewPlace: "Create New Place",
  workplaceName: "Workplace Name",
  enterWorkplaceName: "Enter workplace name",
  paymentMethod: "Payment Method",
  globalProfitLabel: "Global Profit",
  enterGlobalProfit: "Enter global profit",
  monthlyProfitLabel: "Monthly Profit",
  dailySalaryPerEmployee: "Daily Salary per Employee",
  enterDailySalaryPerEmployee: "Enter daily salary per employee",
  enterProfitAmount: "Enter profit amount",
  monthlyPaymentDesc:
    "Monthly payment: a fixed profit is earned each month regardless of the number of working days.",
  dailyPaymentDesc:
    "Daily payment: revenue is tracked per working day based on the daily rate set for this place.",
  globalPaymentDesc:
    "Global payment: a one-time total profit is agreed upon for the entire project duration.",
  monthlyProfitInfo:
    "The monthly profit will be recorded as income for this place each month.",
  dailySalaryRateInfo:
    "Each working day will generate revenue based on the daily salary rate.",
  globalProfitInfo:
    "The global profit represents the total contract amount for the entire project.",
  optional: "Optional",
  canUpdateLater: "You can change or update this later",

  // Form Fields
  enterEmployeeName: "Enter employee name",
  enterPassword: "Enter password",
  enterNewPasswordOptional: "Enter new password (optional)",
  leaveBlankToKeepPassword: "Leave blank to keep current password",
  cannotBeChanged: "Cannot be changed",
  searchByNamePlaceholder: "Search by name…",

  // Salary Type Info
  dailySalaryTypeInfo: "Daily salary will be applied to each working day.",
  monthlySalaryTypeInfo:
    "Monthly salary will be paid once per month regardless of working days.",

  // Permissions
  expensesAccess: "Expenses Access",
  hasAccess: "Has Access",
  noAccess: "No Access",
  placeAccess: "Place Access",
  noPlacesAvailable: "No places available",
  placesSelected: "places selected",

  // Success Messages
  employeeCreatedSuccessfully: "Employee created successfully!",
  employeeActivatedSuccessfully: "Employee activated successfully!",
  employeeUpdatedSuccessfully: "Employee updated successfully!",
  profileUpdatedSuccessfully: "Profile updated successfully!",
  placeCreatedSuccessfully: "Place created successfully!",
  placeActivatedSuccessfully: "Place activated successfully!",

  // Error Messages
  failedToActivatePlace: "Failed to activate place",
  failedToActivateEmployee: "Failed to activate employee",
  failedToCreateEmployee: "Failed to create employee",
  failedToUpdateProfile: "Failed to update profile. Please try again.",
  employeeNameAlreadyTaken: "Employee name is already taken",
  nameAlreadyTaken: "This name is already taken. Please choose another name.",
  failedToCreatePlace: "Failed to create place",
  employeeNameRequired: "Employee name is required",
  placeNameRequired: "Place name is required",
  dailySalaryRequired: "Daily salary is required",
  globalProfitRequired: "Global profit is required",
  enterValidDailySalary: "Please enter a valid daily salary",
  enterValidMonthlySalary: "Please enter a valid monthly salary",
  passwordRequired: "Password is required",
  passwordMinLength: "Password must be at least 4 characters",
  pleaseEnterEmployeeName: "Please enter employee name",
  pleaseEnterPassword: "Please enter password",
  nameRequired: "Name is required",
  userDataNotFound: "User data not found",

  // Confirmation Dialogs
  confirmLogout: "Are you sure you want to log out?",
  confirmDeleteAccount: "Are you sure you want to delete your account?",
  deleteAccountMessage: "This action cannot be undone.",
  confirmActivateEmployee: "Are you sure you want to activate this employee?",
  confirmActivatePlace: "Activate this place?",

  // Subscription
  subscriptionExpired: "Subscription Expired",
  subscriptionExpiredMessage:
    "Your subscription has expired. Please renew to continue using the service.",
  subscriptionExpiringToday: "Subscription Expiring Today",
  subscriptionExpiringTodayMessage:
    "Your subscription expires today. Please renew to avoid service interruption.",
  subscriptionExpiringSoon: "Subscription Expiring Soon",
  contactToRenew: "Contact to Renew",
  contactUsToRenew: "Contact us to renew:",
  weAreAvailable247: "We're available 24/7 to help you renew your subscription",
  helloSubscriptionExpired:
    "Hello, my subscription has expired. I would like to renew it.",
  helloSubscriptionExpiresToday:
    "Hello, my subscription expires today. I would like to renew it.",
  helloSubscriptionExpiresSoon:
    "Hello, my subscription expires soon. I would like to renew it.",
  helloInquire: "Hello, I would like to inquire about the service.",

  // Statistics
  statistics: "Statistics",
  totalSalaries: "Total Salaries",
  totalDailyRevenue: "Total daily revenue collected",
  receivedFromGlobalProfit: "Received from total global profit",
  monthlyProfitFromPlace: "Monthly profit from place",
  totalPaidToDailyEmployees: "Total paid to daily employees",
  totalExpensesThisMonth: "Total expenses this month",
  netProfitLabel: "Net Profit",
  revenueMinus: "Revenue minus costs and expenses",
  dailyOperations: "Daily Operations",
  placePerformance: "Place Performance",
  financialBreakdown: "Financial Breakdown",
  extraProfitLabel: "Extra Profit",
  extraProfitDesc: "Extra profit from additional work",
  extraProfitsReceived: "Extra Profits Received",
  monthlyEmployeesPaid: "Monthly Employees",
  paid: "Paid",
  paymentsReceived: "Payments received",
  noActivity: "No Activity",
  noDataThisMonth: "No data this month",
  selectDifferentMonth: "Select a different month",

  // Expense Types
  materials: "Materials",
  equipment: "Equipment",
  transportation: "Transportation",
  utilities: "Utilities",
  otherExpense: "Other",

  // Actions
  creating: "Creating...",
  updating: "Updating...",
  activating: "Activating...",
  refreshing: "Refreshing…",
  addPayment: "Add Payment",
  addExtra: "Add Extra",
  callUs: "Call Us",
  chatOnWhatsApp: "Chat on WhatsApp",
  sendEmail: "Send Email",
  talkDirectly: "Talk directly with us",
  quickResponse: "Quick response",
  sendMessage: "Send us a message",

  // Language Settings
  chooseYourLanguage: "Choose Your Language",
  selectPreferredLanguage: "Select your preferred language",

  // Invoice
  createNewInvoice: "Create New Invoice",
  noResultsFound2: "No results found",

  // CreateInvoice
  offer: "Offer",
  billTo: "Bill To",
  thankYou: "Thank you for your business",
  printSaveAsPdf: "Print / Save as PDF",
  createdBy: "Created by",
  yourNameBusiness: "Your name / business",
  yourNameOrCompany: "Your Name or Company",
  clientNameLabel: "Client name",
  clientNamePlaceholder: "Client Name / Company",
  clientEmailLabel: "Client email",
  addressLabel: "Address",
  streetAddress: "Street address",
  cityCountry: "City / Country",
  unpaid: "Unpaid",
  invoiceNumberLabel: "Invoice number",
  issueDate: "Issue date",
  dueDate: "Due date",
  description: "Description",
  qty: "Qty",
  rate: "Rate",
  addLineItem: "+ Add line item",
  serviceDescription: "Service description",
  notesPlaceholder:
    "Bank details, payment instructions, or a thank-you note...",
  offerTitle: "Offer Title",
  offerTitlePlaceholder: "e.g. Website Redesign Project",
  preparedFor: "Prepared For",
  validUntil: "Valid Until",
  includeTaxInTotal: "Include tax in total",

  // Place Statistics
  searchByPlaceName: "Search by place name...",
  noPlacesMatchSearch: "No places match your search",
  noPlacesYet: "No Places Yet",
  addPlacesToTrack: "Add places to start tracking performance",
  addPlace: "Add Place",
  global: "Global",
  extraProfit: "Extra Profit",
  invoiceCosts: "Invoice Costs",
  monthlyEmployees: "Monthly Employees",
  dailySalaries: "Daily Salaries",
  newInvoice: "New Invoice",
  expense: "Expense",
  edit: "Edit",
  delete: "Delete",
  dailyRevenueCollected: "Daily revenue collected",
  monthlyPlaceProfit: "Monthly place profit",
  additionalWorkIncome: "Additional work income",
  fixedMonthlySalaries: "Fixed monthly salaries",
  paidToDailyEmployees: "Paid to daily employees",
  revenueMinusCosts: "Revenue minus costs",
  receivedMinusAllCosts: "Received minus all costs",
  profitMinusCosts: "Profit minus costs",
  tapToAdd: "Tap to add",
  manageInvoices: "Manage Invoices",
  linkInvoices: "Link Invoices",
  noInvoicesLinkedYet: "No invoices linked yet",
  totalIlsEquivalent: "Total (ILS equivalent)",
  rateUnavailable: "Rate unavailable — using face value",
  rateLookupFailed: "rate lookup failed",
  analytics: "Analytics",
  dailyBreakdown: "Daily Breakdown",
  costs: "costs",
  days: "days",
};

const ar = {
  manageAndTrackYourContractors: "إدارة وتتبع المقاولين الخاصين بك",
  totalContractors: "إجمالي المقاولين",
  activeContractors: "المقاولون النشطون",
  thisMonth: "هذا الشهر",
  searchContractors: "البحث عن المقاولين...",
  noResultsFound: "لم يتم العثور على نتائج",
  tryDifferentSearchTerm: "جرب مصطلح بحث مختلف",
  inviteYourFirstContractor: "قم بدعوة مقاولك الأول",
  loading: "جاري التحميل...",
  contractor: "مقاول",
  contractorAccount: "حساب مقاول",
  back: "رجوع",
  dashboard: "لوحة التحكم",
  employees: "موظفين",
  expenses: "مصروفات",

  failedToLoadAvailableContractors: "فشل في تحميل المقاولين المتاحين",
  inviteSentSuccessfully: "تم إرسال الدعوة بنجاح",
  failedToSendInvite: "فشل في إرسال الدعوة",
  unnamed: "بدون اسم",
  id: "المعرف",
  pending: "قيد الانتظار",
  invite: "دعوة",
  inviteContractors: "دعوة المقاولين",
  searchById: "البحث بالمعرف...",
  loading: "جاري التحميل...",
  enterIdToSearch: "أدخل المعرف للبحث عن المقاولين",
  noContractorsFound: "لم يتم العثور على مقاولين",

  home: "الرئيسية",
  settings: "الإعدادات",
  user: "مستخدم",
  accountantAccount: "حساب محاسب",
  logout: "تسجيل الخروج",
  dashboard: "لوحة التحكم",

  // Arabic
  unknown: "غير معروف",
  noData: "لا توجد بيانات",
  noInvoicesToExport: "لا توجد فواتير للتصدير",
  invoiceNumber: "رقم الفاتورة",
  vendorName: "اسم المورد",
  businessNumber: "رقم العمل",
  invoiceDate: "تاريخ الفاتورة",
  place: "مكان",
  subTotal: "المجموع الفرعي",
  taxRate: "معدل الضريبة",
  taxAmount: "مبلغ الضريبة",
  totalAmount: "المبلغ الإجمالي",
  totals: "الإجماليات",
  success: "نجح",
  exportedSuccessfully: "تم التصدير بنجاح",
  error: "خطأ",
  exportFailed: "فشل التصدير",
  invoices: "فواتير",
  date: "تاريخ",
  tax: "ضريبة",
  generatedBy: "تم إنشاؤه بواسطة",
  printDialogOpened: "تم فتح مربع حوار الطباعة. اختر 'حفظ كـ PDF' للحفظ.",
  amount: "المبلغ",
  withInvoice: "مع فاتورة",
  yes: "نعم",
  no: "لا",
  note: "ملاحظة",
  invoiceDetails: "تفاصيل الفاتورة",
  expenseDetails: "تفاصيل المصروفات",
  expensesAndInvoices: "المصروفات والفواتير",
  totalExpenses: "إجمالي المصروفات",
  items: "عناصر",
  outOf: "من أصل",
  noInvoice: "بدون فاتورة",
  needsAttention: "يحتاج اهتمام",
  totalSubTotal: "إجمالي المجموع الفرعي",
  totalTax: "إجمالي الضريبة",
  fromInvoices: "من الفواتير",
  totalInvoices: "إجمالي الفواتير",
  expenses: "مصروفات",
  searchInvoices: "البحث في الفواتير...",
  cancel: "إلغاء",
  select: "اختر",
  deselectAll: "إلغاء تحديد الكل",
  selectAll: "تحديد الكل",
  export: "تصدير",
  exportAll: "تصدير الكل",
  noExpensesFound: "لم يتم العثور على مصروفات",
  expensesWillAppearHere: "ستظهر المصروفات هنا",
  noSearchResults: "لا توجد نتائج بحث",
  noInvoicesFound: "لم يتم العثور على فواتير",
  tryDifferentSearch: "جرب مصطلح بحث مختلف",
  invoicesWillAppearHere: "ستظهر الفواتير هنا",
  ok: "موافق",
  exportOptions: "خيارات التصدير",
  chooseExportFormat: "اختر تنسيق التصدير",
  excelDescription: "تصدير كجدول بيانات لتحليل البيانات",
  pdfDescription: "تصدير كمستند منسق للطباعة",
  total: "الإجمالي",
  place: "مكان",
  me: "أنا",
  sunday: "الأحد",
  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  workSlip: "كشف العمل",
  contractor: "مقاول",
  employeeName: "اسم الموظف",
  salaryType: "نوع الراتب",
  monthlySalary: "راتب شهري",
  dailySalary: "أجر يومي",
  employeeInformation: "معلومات الموظف",
  summary: "ملخص",
  workingDays: "أيام العمل",
  totalSalaryMonth: "إجمالي الراتب (الشهر)",
  avgPerDay: "متوسط ​​لكل يوم",
  avgDaily: "المتوسط ​​اليومي",
  workDays: "أيام العمل",
  day: "يوم",
  dayName: "اسم اليوم",
  salary: "راتب",
  manager: "مدير",
  notes: "ملاحظات",
  worked: "عمل",
  noWorkDataForMonth: "لا توجد بيانات عمل لهذا الشهر",
  generatedOn: "تم إنشاؤه في",
  selectMonth: "اختر الشهر",
  excelExportedSuccessfully: "تم تصدير Excel بنجاح",
  failedToExportExcel: "فشل تصدير Excel",
  pleaseSelectMonth: "يرجى تحديد شهر أولاً",
  exportWorkSlip: "تصدير كشف العمل",
  chooseExportFormat: "اختر تنسيق التصدير",
  excelDescription: "تصدير كجدول بيانات لتحليل البيانات",
  pdfDescription: "تصدير كمستند منسق للطباعة",
  monthly: "شهري",
  daily: "يومي",
  monthly: "شهري",
  daily: "يومي",
  manager: "مدير",
  employee: "موظف",
  employees: "موظفين",
  managers: "المديرون",
  id: "المعرف",
  contractor: "مقاول",
  searchByName: "البحث بالاسم...",
  noEmployeesMatchSearch: "لا يوجد موظفين يطابقون بحثك",
  noEmployeesFound: "لم يتم العثور على موظفين",
  tryDifferentSearch: "جرب مصطلح بحث مختلف",
  pullDownToRefresh: "اسحب لأسفل للتحديث",

  failedToLoadContractors: "فشل في تحميل المقاولين",
  phoneNumberNotAvailable: "رقم الهاتف غير متوفر",
  emailNotAvailable: "البريد الإلكتروني غير متوفر",
  active: "نشط",
  noContactInfo: "لا توجد معلومات اتصال",
  id: "المعرف",
  loadingContractors: "جاري تحميل المقاولين...",
  myContractors: "مقاوليي",
  contractors: "مقاولين",
  inviteContractor: "دعوة مقاول",
  activeContractors: "المقاولون النشطون",
  noContractorsFound: "لم يتم العثور على مقاولين",
  contractorsWillAppearHere: "سيظهر المقاولون هنا",

  settings: "الإعدادات",
  manageYourPreferences: "إدارة تفضيلاتك",
  language: "اللغة",
  change: "تغيير",
  selectLanguage: "اختر اللغة",
  chooseYourPreferredLanguage: "اختر لغتك المفضلة",

  // Language names
  languageEnglish: "الإنجليزية",
  languageArabic: "العربية",
  languageHebrew: "العبرية",
  Contact: "اتصل بنا",
  GetInTouch: "تواصل معنا",
  ContactDescription: "لديك أسئلة؟ نحن هنا للمساعدة!",
  WhatsApp: "واتساب",
  ChatWithUs: "تحدث معنا",
  Phone: "هاتف",
  CallUs: "اتصل بنا مباشرة",
  SMS: "رسالة نصية",
  TextUs: "أرسل لنا رسالة",
  ContactAvailability: "متاحون على مدار الساعة لمساعدتك",
  // Navigation
  Features: "المميزات",
  MobileApp: "تطبيق الموبايل",
  Benefits: "الفوائد",
  GetStarted: "ابدأ الآن",

  // Hero Section
  TrustedByProfessionals: "🚀 موثوق به من قبل أكثر من 10,000 محترف",
  AppointmentManagement: "إدارة المواعيد،",
  Simplified: "مبسطة",
  HeroDescription:
    "حوّل فوضى جدولة المواعيد إلى عمليات سلسة. يجمع نيهول عيسيك بين أدوات الحجز القوية وإدارة العملاء والتحليلات في منصة واحدة جميلة.",
  StartFreeTrial: "ابدأ تجربة مجانية",
  WatchDemo: "شاهد العرض التوضيحي",

  // Stats
  ActiveUsers: "مستخدم نشط",
  AppointmentsBooked: "موعد محجوز",
  Uptime: "وقت التشغيل",
  UserRating: "تقييم المستخدم",

  // Features Section
  EverythingYouNeedTo: "كل ما تحتاجه",
  Succeed: "للنجاح",
  BuiltForProfessionals: "مصمم للمحترفين الذين يطالبون بالتميز في كل التفاصيل",

  SmartScheduling: "جدولة ذكية",
  SmartSchedulingDesc:
    "إدارة ذكية للمواعيد تتكيف مع سير عملك وتزيل الحجوزات المزدوجة",
  SmartSchedulingStat: "دقة 99.8%",

  ClientManagement: "إدارة العملاء",
  ClientManagementDesc:
    "ملفات تعريف شاملة للعملاء مع السجل والتفضيلات والتواصل الآلي",
  ClientManagementStat: "توفير 50% من الوقت",

  AnalyticsInsights: "التحليلات والرؤى",
  AnalyticsInsightsDesc:
    "إحصائيات في الوقت الفعلي وتحليلات تنبؤية لتحسين أداء عملك",
  AnalyticsInsightsStat: "نمو 3 أضعاف",

  // Mobile App Section
  AvailableOnMobile: "متاح على الموبايل",
  ManageEverything: "إدارة كل شيء",
  OnTheGo: "أثناء التنقل",
  MobileAppDescription:
    "قم بتنزيل تطبيق نيهول عيسيك للهاتف المحمول وتحكم في مواعيدك من أي مكان",

  YourBusinessInYourPocket: "عملك في جيبك",
  MobileAppFullDescription:
    "يمنحك تطبيق نيهول عيسيك للهاتف المحمول تحكمًا كاملاً في مواعيدك وعملائك وتحليلات عملك - مباشرة من هاتفك الذكي.",

  RealTimeSync: "مزامنة فورية",
  RealTimeSyncDesc: "تحديثات فورية عبر جميع أجهزتك",

  PushNotifications: "إشعارات فورية",
  PushNotificationsDesc: "لا تفوت أي موعد أو رسالة",

  WorksOffline: "يعمل بدون إنترنت",
  WorksOfflineDesc: "الوصول إلى بياناتك حتى بدون إنترنت",

  DownloadNow: "حمّل الآن",
  GetItOnGooglePlay: "احصل عليه من",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "حمّل على",
  AppStore: "App Store",

  FreeToDownload:
    "✨ مجاني للتحميل • متاح في جميع أنحاء العالم • تحديثات منتظمة",

  SeeItInAction: "شاهده في العمل",

  // Benefits Section
  WhyProfessionalsChoose: "لماذا يختار المحترفون",
  NeholEsek: "نيهول عيسيك",
  BenefitsDescription:
    "انضم إلى آلاف الشركات التي حولت عملياتها بإدارة المواعيد الذكية.",

  SaveHoursDaily: "وفر ساعات يوميًا",
  SaveHoursDesc: "أتمتة المهام المتكررة وركز على ما يهم",

  NeverMissAppointment: "لا تفوت أي موعد",
  NeverMissDesc: "تذكيرات تلقائية وإشعارات ذكية",

  InstantSetup: "إعداد فوري",
  InstantSetupDesc: "ابدأ في أقل من 5 دقائق",

  BoostRevenue: "زد إيراداتك",
  BoostRevenueDesc: "قلل عدم الحضور بنسبة 67% مع التذكيرات الذكية",

  TodaysAppointments: "مواعيد اليوم",
  ClientSatisfaction: "رضا العملاء",
  ThisMonthRevenue: "إيرادات هذا الشهر",
  PercentageFromLastMonth: "+23% من الشهر الماضي",
  ActiveClients: "عملاء نشطون",
  ShowRate: "معدل الحضور",

  // CTA Section
  ReadyToTransform: "هل أنت مستعد لتحويل عملك؟",
  CTADescription:
    "انضم إلى أكثر من 10,000 محترف يثقون في نيهول عيسيك لاحتياجات الجدولة الخاصة بهم",
  DownloadApp: "حمّل التطبيق",
  FreeTrial:
    "لا حاجة لبطاقة ائتمان • تجربة مجانية لمدة 45 يومًا • إلغاء في أي وقت",

  // Footer
  Privacy: "الخصوصية",
  Terms: "الشروط",
  Contact: "اتصل بنا",
  CopyrightMainPage: "© 2024 نيهول عيسيك. جميع الحقوق محفوظة.",
  CustomerReviews: "آراء العملاء",
  SeeWhatOurCustomersSay: "اطلع على آراء عملائنا",
  OutOf: "من أصل",
  Reviews: "مراجعات",
  NoComment: "لا يوجد تعليق",
  myappointments: "مواعيدي",
  TheMainPage: "الصفحة الرئيسية",
  Gallery: "معرض الصور",
  ContactInfo: "معلومات الاتصال",
  Chooselanguage: "اختر اللغة",
  Home: "الرئيسية",
  MyAppointments: "مواعيدي",
  Loading: "جاري التحميل...",
  BookYourAppointment: "احجز موعدك",
  ChoosePreferredDateTime: "اختر التاريخ والوقت المفضل",
  OnlineBookingComingSoon: "الحجز عبر الإنترنت قريباً",
  BarberStopDescription:
    "يتيح BarberStop جدولة المواعيد من خلال التطبيق! حالياً، يتم إعداد هذه الميزة.",
  InTheMeantime: "في هذه الأثناء، احجز موعدك عبر:",
  SMS: "رسالة نصية",
  PhoneCall: "مكالمة هاتفية",
  WhatsApp: "واتساب",
  Tip: "نصيحة:",
  MentionBarberStop: 'اذكر "BarberStop" عند التواصل!',
  ModernBookingSolutions: "حلول الحجز الحديثة",
  Copyright: "© 2025 NeholEsek. جميع الحقوق محفوظة.",

  // New Business Owner translations
  ForBusinessOwners: "لأصحاب الأعمال",
  WantYourOwnBusinessApp: "تريد عملك الخاص؟",
  DownloadNeholEsekForBusinessOwners:
    "قم بتنزيل نيهول عيسيك وابدأ في إدارة صالون الحلاقة الخاص بك اليوم!",
  Business: "أعمال",
  WhatsIncluded: "ما هو مشمول:",
  ManageAppointments: "إدارة المواعيد عبر الإنترنت",
  TrackCustomers: "تتبع عملائك",
  IncreaseRevenue: "زيادة إيراداتك",
  BusinessAnalytics: "تحليلات وتقارير الأعمال",
  JoinThousandsOfBarbers:
    "انضم إلى آلاف الحلاقين الذين يديرون أعمالهم باستخدام نيهول عيسيك",
  DownloadOnThe: "التنزيل على",
  GetItOn: "احصل عليه من",

  // MPHomeApps translations
  PleaseLoginToView: "يرجى تسجيل الدخول لعرض مواعيدك",
  SignInToAccess: "سجل الدخول للوصول إلى سجل المواعيد وإدارة الحجوزات",
  LoadingYourAppointments: "جاري تحميل مواعيدك...",
  ManageYourBookings: "إدارة حجوزاتك القادمة",
  User: "مستخدم",
  Logout: "تسجيل الخروج",
  NoAppointmentsYet: "لا توجد مواعيد بعد",
  BookYourFirst: "احجز موعدك الأول للبدء في خدماتنا",
  TodaysAppointment: "موعد اليوم",
  Past: "سابق",
  Min: "دقيقة",
  Services: "الخدمات",
  Total: "المجموع",
  Barber: "الحلاق:",
  CancelAppointment: "إلغاء الموعد",
  CancelAppointmentQuestion: "إلغاء الموعد؟",
  CancelConfirmation:
    "هل أنت متأكد من أنك تريد إلغاء هذا الموعد؟ لا يمكن التراجع عن هذا الإجراء.",
  KeepIt: "الاحتفاظ به",
  YesCancel: "نعم، إلغاء",

  // MPHomeBookApp translations
  Login: "تسجيل الدخول",
  BarberStep: "الحلاق",
  ServicesStep: "الخدمات",
  Book: "حجز",
  ChooseYourBarber: "اختر الحلاق",
  SelectBarberForAppointment: "اختر حلاقاً لموعدك",
  ProfessionalBarber: "حلاق محترف",
  SelectABarber: "اختر حلاقاً",
  ChoosePreferredBarber: "اختر الحلاق المفضل لديك للمتابعة",
  NextSelectServices: "التالي: اختر الخدمات ←",
  YourBarber: "الحلاق الخاص بك",
  Change: "تغيير",
  SelectYourServices: "اختر خدماتك",
  ChooseOneOrMoreServices: "اختر خدمة واحدة أو أكثر لموعدك",
  TotalDuration: "المدة الإجمالية",
  TotalPrice: "السعر الإجمالي",
  SelectAtLeastOneService: "اختر خدمة واحدة على الأقل",
  ChooseFromServices: "اختر من خدماتنا أعلاه للمتابعة",
  NextSelectDateTime: "التالي: اختر التاريخ والوقت ←",
  SelectedServices: "الخدمات المحددة",
  Edit: "تعديل",
  SelectDate: "اختر التاريخ",
  Today: "اليوم",
  AvailableTimes: "الأوقات المتاحة",
  TotalDurationNeeded: "المدة الإجمالية المطلوبة:",
  Minutes: "دقيقة",
  ShowingConsecutiveSlots: "عرض الأوقات ذات الفترات المتتالية الكافية",
  NoAvailableAppointments: "لا توجد مواعيد متاحة",
  NoConsecutiveSlotsFound:
    "لم يتم العثور على فترات متتالية بـ {duration} دقيقة متاحة. حاول اختيار تاريخ آخر أو خدمات أقل.",
  PleaseSelectAnotherDate: "يرجى اختيار تاريخ آخر",
  BackToServices: "→ العودة إلى الخدمات",

  // MPHomeLoginWithPhoneNumber translations
  Phone: "الهاتف",
  Verify: "تحقق",
  Name: "الاسم",
  Welcome: "مرحباً! 👋",
  EnterPhoneToGetStarted: "أدخل رقم هاتفك للبدء",
  PhoneNumber: "رقم الهاتف",
  FullNumber: "الرقم الكامل:",
  Sending: "جاري الإرسال...",
  SendVerificationCode: "إرسال رمز التحقق",
  VerifyYourNumber: "تحقق من رقمك 🔐",
  WeSentCodeTo: "أرسلنا رمزاً إلى",
  VerificationCode: "رمز التحقق",
  EnterSixDigitCode: "أدخل الرمز المكون من 6 أرقام",
  Verifying: "جاري التحقق...",
  VerifyCode: "تحقق من الرمز",
  ChangePhoneNumber: "→ تغيير رقم الهاتف",
  AlmostThere: "تقريباً انتهينا! ✨",
  EnterNameToComplete: "الرجاء إدخال اسمك لإكمال التسجيل",
  YourName: "اسمك",
  EnterFullName: "أدخل اسمك الكامل",
  Completing: "جاري الإكمال...",
  CompleteRegistration: "إكمال التسجيل",
  PleaseEnterValidPhone: "الرجاء إدخال رقم هاتف صحيح",
  OTPSentTo: "تم إرسال رمز التحقق إلى",
  ErrorMessage: "خطأ:",
  PhoneVerifiedSuccessfully: "تم التحقق من الهاتف بنجاح!",
  PleaseEnterValidOTP: "الرجاء إدخال رمز صحيح مكون من 6 أرقام",
  InvalidOTP: "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
  PleaseEnterYourName: "الرجاء إدخال اسمك",
  LoginSuccessful: "تم تسجيل الدخول بنجاح!",
  FailedToSaveUser: "فشل حفظ المستخدم:",

  // MPHomeModalMakeApp translations
  ConfirmYourBooking: "أكد حجزك",
  ReviewAppointmentDetails: "راجع تفاصيل موعدك أدناه",
  YourInformation: "معلوماتك",
  Guest: "ضيف",
  NotAvailable: "غير متوفر",
  BarberDetails: "تفاصيل الحلاق",
  AppointmentDetails: "تفاصيل الموعد",
  Date: "التاريخ",
  Time: "الوقت",
  Duration: "المدة",
  SelectedServicesUpper: "الخدمات المحددة",
  Cancel: "إلغاء",
  BookingInProgress: "جاري الحجز...",
  ConfirmBooking: "تأكيد الحجز",
  ConfirmationMessage: "رسالة التأكيد",
  WhatsAppConfirmation: "ستتلقى رسالة تأكيد عبر الواتساب قريباً",

  // Contractor Landing Page
  signIn: "تسجيل الدخول",
  demo: "عرض توضيحي",
  pricing: "الأسعار",
  availableOnMobileWeb: "📱 متاح على الجوال والويب",
  heroTitleContractor: "أدر أعمال البناء الخاصة بك مثل",
  heroPro: "محترف",
  heroDescriptionContractor:
    "حل شامل لإدارة القوى العاملة للمقاولين. تتبع الموظفين، وأدر الرواتب، وراقب الأرباح، وتحكم في النفقات في منصة واحدة قوية.",
  getStartedFree: "ابدأ مجاناً",
  noCreditCardRequired: "لا يلزم بطاقة ائتمان",
  fortyFiveDayFreeTrial: "تجربة مجانية لمدة 45 يوماً",
  todaysOverview: "نظرة عامة لليوم",
  liveLabel: "مباشر",
  activeEmployees: "الموظفون النشطون",
  monthlyProfit: "الربح الشهري",
  activeSites: "المواقع النشطة",
  growthRate: "معدل النمو",
  revenueVsExpenses: "الإيرادات مقابل النفقات",
  everythingYouNeedToSucceed: "كل ما تحتاجه للنجاح",
  powerfulFeaturesForContractors: "ميزات قوية مصممة للمقاولين العصريين",
  featureEmployeeManagement: "إدارة الموظفين",
  featureEmployeeManagementDesc:
    "تتبع الحضور اليومي وساعات العمل وعيّن الموظفين لمواقع عمل محددة بسهولة",
  featureSalaryPayroll: "الراتب والرواتب",
  featureSalaryPayrollDesc:
    "حسابات راتب تلقائية بناءً على أيام وساعات العمل مع سجلات دفع مفصلة",
  featureProfitAnalytics: "تحليلات الأرباح",
  featureProfitAnalyticsDesc:
    "تتبع الأرباح في الوقت الفعلي مع تقارير مالية شاملة وإدارة النفقات",
  featureRoleBasedAccess: "الوصول القائم على الأدوار",
  featureRoleBasedAccessDesc:
    "نظام هرمي: المقاول ← المديرون ← المستخدمون مع أذونات قابلة للتخصيص",
  featureJobSiteTracking: "تتبع موقع العمل",
  featureJobSiteTrackingDesc:
    "أنشئ وأدر أماكن عمل متعددة وعيّن الفرق وتابع التقدم يومياً",
  featureExpenseControl: "التحكم في النفقات",
  featureExpenseControlDesc:
    "تتبع جميع نفقات المشروع مع مسارات عمل للموافقة ومراقبة الميزانية",
  hierarchicalAccessControl: "التحكم في الوصول الهرمي",
  completeControlWhoSeesWhat: "تحكم كامل في من يرى ماذا",
  fullAccessToEverything: "وصول كامل لكل شيء",
  createWorkplaces: "إنشاء أماكن العمل",
  manageAllEmployees: "إدارة جميع الموظفين",
  createManagerAccounts: "إنشاء حسابات المديرين",
  setPermissionsAccess: "تعيين الأذونات والوصول",
  viewAllFinancialData: "عرض جميع البيانات المالية",
  assignedSiteAccess: "الوصول إلى المواقع المعينة",
  accessAssignedSites: "الوصول إلى المواقع المعينة",
  enterDailyAttendance: "إدخال الحضور اليومي",
  createUserAccounts: "إنشاء حسابات المستخدمين",
  submitExpensesIfAllowed: "تقديم النفقات (إذا كان مسموحاً)",
  viewPermittedData: "عرض البيانات المصرح بها",
  limitedAccess: "وصول محدود",
  viewAssignedTasks: "عرض المهام المعينة",
  checkInOutOfSites: "تسجيل الدخول/الخروج من المواقع",
  viewOwnWorkHistory: "عرض سجل العمل الخاص",
  accessBasicReports: "الوصول إلى التقارير الأساسية",
  submitTimesheets: "تقديم كشوف الدوام",
  realTimeDataVisualization: "تصور وإدارة البيانات في الوقت الفعلي",
  daysWorked: "أيام العمل",
  statusLabel: "الحالة",
  jobSitePerformance: "أداء موقع العمل",
  siteName: "اسم الموقع",
  revenueLabel: "الإيرادات",
  profitLabel: "الربح",
  powerfulAnalyticsDashboard: "لوحة تحليلات قوية",
  trackBusinessPerformance: "تتبع أداء عملك بتصورات جميلة",
  totalRevenue: "إجمالي الإيرادات",
  netProfit: "صافي الربح",
  activeProjects: "المشاريع النشطة",
  last6Months: "آخر 6 أشهر",
  expenseBreakdown: "تفصيل النفقات",
  projectCompletion: "اكتمال المشروع",
  performanceMetrics: "مقاييس الأداء",
  efficiencyRate: "معدل الكفاءة",
  onTimeDelivery: "التسليم في الوقت المحدد",
  ctaDescriptionContractors:
    "انضم إلى مئات المقاولين الذين بسّطوا عملياتهم مع ContractorPro",
  scheduleDemo: "جدولة عرض توضيحي",
  noCreditCardFreeTrialCancel:
    "لا يلزم بطاقة ائتمان • تجربة مجانية 45 يوماً • إلغاء في أي وقت",
  footerDescription:
    "الحل المتكامل للمقاولين العصريين لإدارة القوى العاملة والشؤون المالية.",
  footerProduct: "المنتج",
  footerCompany: "الشركة",
  footerLegal: "القانوني",
  aboutUs: "من نحن",
  careers: "الوظائف",
  blog: "المدونة",
  privacyPolicy: "سياسة الخصوصية",
  termsOfService: "شروط الخدمة",
  securityLabel: "الأمان",
  faq: "الأسئلة الشائعة",

  // BossMainPage Navigation
  places: "الأماكن",
  general: "عام",
  calc: "الحاسبة",
  createInvoice: "إنشاء فاتورة",
  createOffer: "إنشاء العرض",

  ownerAccount: "حساب المالك",
  workforce: "القوى العاملة",
  myEmployees: "موظفيي",
  contactUs: "اتصل بنا",
  accountant: "محاسب",
  deleteAccount: "حذف الحساب",

  // Calculator
  projectCalculator: "حاسبة المشروع",
  smallProject: "مشروع صغير",
  bigProject: "مشروع كبير",
  oneTimeFixedPriceEstimate: "تقدير سعر ثابت لمرة واحدة",
  monthByMonthBilling: "فوترة شهرية حسب التقدم",

  // Employee Management
  createEmployee: "إنشاء موظف",
  createNewEmployee: "إنشاء موظف جديد",
  addNewTeamMember: "إضافة عضو جديد للفريق",
  updateEmployee: "تحديث الموظف",
  updateProfile: "تحديث الملف الشخصي",
  employeeType: "نوع الموظف",
  employeeId: "معرف الموظف",
  employeeStatus: "حالة الموظف",
  inactive: "غير نشط",
  inactiveEmployees: "الموظفون غير النشطون",
  inactivePlaces: "الأماكن غير النشطة",
  noInactiveEmployees: "لا يوجد موظفون غير نشطون",
  noInactivePlaces: "لا توجد أماكن غير نشطة",
  allEmployeesActive: "جميع الموظفين نشطون حالياً",
  allPlacesActive: "جميع الأماكن نشطة",
  noEmployeesYet: "لا يوجد موظفون بعد",
  tapButtonToAddFirstMember: "اضغط على زر + لإضافة أول عضو في الفريق.",
  nothingMatchesSearch: "لا يوجد ما يطابق بحثك. جرب مصطلحاً مختلفاً.",
  employeeTypeDesc: "يمتلك الموظفون وصولاً قياسياً إلى مهامهم ومناطق عملهم.",
  managerTypeDesc:
    "يمتلك المديرون صلاحيات متقدمة تشمل الإشراف على الفريق وإمكانيات التقارير.",

  // Place Management
  createPlace: "إنشاء مكان",
  createNewPlace: "إنشاء مكان جديد",
  workplaceName: "اسم مكان العمل",
  enterWorkplaceName: "أدخل اسم مكان العمل",
  paymentMethod: "طريقة الدفع",
  globalProfitLabel: "الربح الإجمالي",
  enterGlobalProfit: "أدخل الربح الإجمالي",
  monthlyProfitLabel: "الربح الشهري",
  dailySalaryPerEmployee: "الأجر اليومي للموظف",
  enterDailySalaryPerEmployee: "أدخل الأجر اليومي للموظف",
  enterProfitAmount: "أدخل مبلغ الربح",
  monthlyPaymentDesc:
    "الدفع الشهري: يتم كسب ربح ثابت كل شهر بغض النظر عن عدد أيام العمل.",
  dailyPaymentDesc:
    "الدفع اليومي: يتم تتبع الإيرادات لكل يوم عمل بناءً على المعدل اليومي لهذا المكان.",
  globalPaymentDesc:
    "الدفع الإجمالي: يتم الاتفاق على ربح إجمالي لمرة واحدة لمدة المشروع بأكملها.",
  monthlyProfitInfo: "سيتم تسجيل الربح الشهري كدخل لهذا المكان كل شهر.",
  dailySalaryRateInfo: "سيولد كل يوم عمل إيرادات بناءً على معدل الأجر اليومي.",
  globalProfitInfo:
    "يمثل الربح الإجمالي إجمالي مبلغ العقد لمدة المشروع بأكملها.",
  optional: "اختياري",
  canUpdateLater: "يمكنك تغيير هذا أو تحديثه لاحقاً",

  // Form Fields
  enterEmployeeName: "أدخل اسم الموظف",
  enterPassword: "أدخل كلمة المرور",
  enterNewPasswordOptional: "أدخل كلمة مرور جديدة (اختياري)",
  leaveBlankToKeepPassword: "اتركه فارغاً للاحتفاظ بكلمة المرور الحالية",
  cannotBeChanged: "لا يمكن تغييره",
  searchByNamePlaceholder: "البحث بالاسم...",

  // Salary Type Info
  dailySalaryTypeInfo: "سيتم تطبيق الأجر اليومي على كل يوم عمل.",
  monthlySalaryTypeInfo:
    "سيتم دفع الراتب الشهري مرة واحدة في الشهر بغض النظر عن أيام العمل.",

  // Permissions
  expensesAccess: "الوصول إلى المصروفات",
  hasAccess: "لديه وصول",
  noAccess: "لا يوجد وصول",
  placeAccess: "الوصول إلى المكان",
  noPlacesAvailable: "لا توجد أماكن متاحة",
  placesSelected: "أماكن محددة",

  // Success Messages
  employeeCreatedSuccessfully: "تم إنشاء الموظف بنجاح!",
  employeeActivatedSuccessfully: "تم تفعيل الموظف بنجاح!",
  employeeUpdatedSuccessfully: "تم تحديث الموظف بنجاح!",
  profileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح!",
  placeCreatedSuccessfully: "تم إنشاء المكان بنجاح!",
  placeActivatedSuccessfully: "تم تفعيل المكان بنجاح!",

  // Error Messages
  failedToActivatePlace: "فشل في تفعيل المكان",
  failedToActivateEmployee: "فشل في تفعيل الموظف",
  failedToCreateEmployee: "فشل في إنشاء الموظف",
  failedToUpdateProfile: "فشل في تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.",
  employeeNameAlreadyTaken: "اسم الموظف مأخوذ بالفعل",
  nameAlreadyTaken: "هذا الاسم مأخوذ بالفعل. يرجى اختيار اسم آخر.",
  failedToCreatePlace: "فشل في إنشاء المكان",
  employeeNameRequired: "اسم الموظف مطلوب",
  placeNameRequired: "اسم المكان مطلوب",
  dailySalaryRequired: "الأجر اليومي مطلوب",
  globalProfitRequired: "الربح الإجمالي مطلوب",
  enterValidDailySalary: "يرجى إدخال أجر يومي صحيح",
  enterValidMonthlySalary: "يرجى إدخال راتب شهري صحيح",
  passwordRequired: "كلمة المرور مطلوبة",
  passwordMinLength: "يجب أن تكون كلمة المرور 4 أحرف على الأقل",
  pleaseEnterEmployeeName: "يرجى إدخال اسم الموظف",
  pleaseEnterPassword: "يرجى إدخال كلمة المرور",
  nameRequired: "الاسم مطلوب",
  userDataNotFound: "بيانات المستخدم غير موجودة",

  // Confirmation Dialogs
  confirmLogout: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
  confirmDeleteAccount: "هل أنت متأكد من أنك تريد حذف حسابك؟",
  deleteAccountMessage: "لا يمكن التراجع عن هذا الإجراء.",
  confirmActivateEmployee: "هل أنت متأكد من أنك تريد تفعيل هذا الموظف؟",
  confirmActivatePlace: "تفعيل هذا المكان؟",

  // Subscription
  subscriptionExpired: "انتهت صلاحية الاشتراك",
  subscriptionExpiredMessage:
    "انتهت صلاحية اشتراكك. يرجى التجديد للاستمرار في استخدام الخدمة.",
  subscriptionExpiringToday: "الاشتراك ينتهي اليوم",
  subscriptionExpiringTodayMessage:
    "ينتهي اشتراكك اليوم. يرجى التجديد لتجنب انقطاع الخدمة.",
  subscriptionExpiringSoon: "الاشتراك ينتهي قريباً",
  contactToRenew: "اتصل للتجديد",
  contactUsToRenew: "اتصل بنا للتجديد:",
  weAreAvailable247: "نحن متاحون على مدار الساعة لمساعدتك في تجديد اشتراكك",
  helloSubscriptionExpired: "مرحباً، لقد انتهت صلاحية اشتراكي. أود تجديده.",
  helloSubscriptionExpiresToday: "مرحباً، اشتراكي ينتهي اليوم. أود تجديده.",
  helloSubscriptionExpiresSoon: "مرحباً، اشتراكي ينتهي قريباً. أود تجديده.",
  helloInquire: "مرحباً، أود الاستفسار عن الخدمة.",

  // Statistics
  statistics: "إحصائيات",
  totalSalaries: "إجمالي الرواتب",
  totalDailyRevenue: "إجمالي الإيرادات اليومية المحصلة",
  receivedFromGlobalProfit: "المستلم من إجمالي الربح الكلي",
  monthlyProfitFromPlace: "الربح الشهري من المكان",
  totalPaidToDailyEmployees: "إجمالي المدفوع للموظفين اليوميين",
  totalExpensesThisMonth: "إجمالي المصروفات هذا الشهر",
  netProfitLabel: "صافي الربح",
  revenueMinus: "الإيرادات ناقص التكاليف والمصروفات",
  dailyOperations: "العمليات اليومية",
  placePerformance: "أداء المكان",
  financialBreakdown: "التفصيل المالي",
  extraProfitLabel: "ربح إضافي",
  extraProfitDesc: "ربح إضافي من أعمال إضافية",
  extraProfitsReceived: "الأرباح الإضافية المستلمة",
  monthlyEmployeesPaid: "الموظفون الشهريون",
  paid: "مدفوع",
  paymentsReceived: "المدفوعات المستلمة",
  noActivity: "لا يوجد نشاط",
  noDataThisMonth: "لا توجد بيانات هذا الشهر",
  selectDifferentMonth: "اختر شهراً مختلفاً",

  // Expense Types
  materials: "مواد",
  equipment: "معدات",
  transportation: "نقل",
  utilities: "مرافق",
  otherExpense: "أخرى",

  // Actions
  creating: "جاري الإنشاء...",
  updating: "جاري التحديث...",
  activating: "جاري التفعيل...",
  refreshing: "جاري التحديث...",
  addPayment: "إضافة دفعة",
  addExtra: "إضافة إضافي",
  callUs: "اتصل بنا",
  chatOnWhatsApp: "تحدث عبر واتساب",
  sendEmail: "إرسال بريد إلكتروني",
  talkDirectly: "تحدث معنا مباشرة",
  quickResponse: "رد سريع",
  sendMessage: "أرسل لنا رسالة",

  // Language Settings
  chooseYourLanguage: "اختر لغتك",
  selectPreferredLanguage: "اختر لغتك المفضلة",

  // Invoice
  createNewInvoice: "إنشاء فاتورة جديدة",
  noResultsFound2: "لم يتم العثور على نتائج",

  // CreateInvoice
  offer: "عرض سعر",
  billTo: "فاتورة إلى",
  thankYou: "شكراً لتعاملكم معنا",
  printSaveAsPdf: "طباعة / حفظ كـ PDF",
  createdBy: "تم إنشاؤه بواسطة",
  yourNameBusiness: "اسمك / شركتك",
  yourNameOrCompany: "اسمك أو شركتك",
  clientNameLabel: "اسم العميل",
  clientNamePlaceholder: "اسم العميل / الشركة",
  clientEmailLabel: "بريد العميل",
  addressLabel: "العنوان",
  streetAddress: "عنوان الشارع",
  cityCountry: "المدينة / الدولة",
  unpaid: "غير مدفوع",
  invoiceNumberLabel: "رقم الفاتورة",
  issueDate: "تاريخ الإصدار",
  dueDate: "تاريخ الاستحقاق",
  description: "الوصف",
  qty: "الكمية",
  rate: "السعر",
  addLineItem: "+ إضافة بند",
  serviceDescription: "وصف الخدمة",
  notesPlaceholder: "تفاصيل البنك، تعليمات الدفع، أو رسالة شكر...",
  offerTitle: "عنوان العرض",
  offerTitlePlaceholder: "مثل: مشروع تصميم موقع",
  preparedFor: "مُقَدَّم لـ",
  validUntil: "صالح حتى",
  includeTaxInTotal: "تضمين الضريبة في الإجمالي",

  // Place Statistics
  searchByPlaceName: "البحث باسم المكان...",
  noPlacesMatchSearch: "لا توجد أماكن تطابق بحثك",
  noPlacesYet: "لا توجد أماكن بعد",
  addPlacesToTrack: "أضف أماكن لبدء تتبع الأداء",
  addPlace: "إضافة مكان",
  global: "إجمالي",
  extraProfit: "ربح إضافي",
  invoiceCosts: "تكاليف الفواتير",
  monthlyEmployees: "الموظفون الشهريون",
  dailySalaries: "الرواتب اليومية",
  newInvoice: "فاتورة جديدة",
  expense: "مصروف",
  edit: "تعديل",
  delete: "حذف",
  dailyRevenueCollected: "الإيرادات اليومية المحصلة",
  monthlyPlaceProfit: "الربح الشهري للمكان",
  additionalWorkIncome: "دخل العمل الإضافي",
  fixedMonthlySalaries: "الرواتب الشهرية الثابتة",
  paidToDailyEmployees: "مدفوع للموظفين اليوميين",
  revenueMinusCosts: "الإيرادات ناقص التكاليف",
  receivedMinusAllCosts: "المستلم ناقص جميع التكاليف",
  profitMinusCosts: "الربح ناقص التكاليف",
  tapToAdd: "اضغط للإضافة",
  manageInvoices: "إدارة الفواتير",
  linkInvoices: "ربط الفواتير",
  noInvoicesLinkedYet: "لا توجد فواتير مرتبطة بعد",
  totalIlsEquivalent: "الإجمالي (ما يعادل شيكل)",
  rateUnavailable: "السعر غير متوفر — باستخدام القيمة الاسمية",
  rateLookupFailed: "فشل البحث عن السعر",
  analytics: "التحليلات",
  dailyBreakdown: "التفصيل اليومي",
  costs: "تكاليف",
  days: "أيام",
};

const he = {
  manageAndTrackYourContractors: "נהל ועקוב אחר הקבלנים שלך",
  totalContractors: "סה״כ קבלנים",
  activeContractors: "קבלנים פעילים",
  thisMonth: "החודש",
  searchContractors: "חפש קבלנים...",
  noResultsFound: "לא נמצאו תוצאות",
  tryDifferentSearchTerm: "נסה מונח חיפוש אחר",
  inviteYourFirstContractor: "הזמן את הקבלן הראשון שלך",
  loading: "טוען...",
  contractor: "קבלן",
  contractorAccount: "חשבון קבלן",
  back: "חזור",
  dashboard: "לוח בקרה",
  employees: "עובדים",
  expenses: "הוצאות",
  failedToLoadAvailableContractors: "נכשל בטעינת קבלנים זמינים",
  inviteSentSuccessfully: "ההזמנה נשלחה בהצלחה",
  failedToSendInvite: "נכשל בשליחת ההזמנה",
  unnamed: "ללא שם",
  id: "מזהה",
  pending: "ממתין",
  invite: "הזמן",
  inviteContractors: "הזמן קבלנים",
  searchById: "חיפוש לפי מזהה...",
  loading: "טוען...",
  enterIdToSearch: "הזן מזהה לחיפוש קבלנים",
  noContractorsFound: "לא נמצאו קבלנים",
  home: "בית",
  settings: "הגדרות",
  user: "משתמש",
  accountantAccount: "חשבון רואה חשבון",
  logout: "התנתק",
  dashboard: "לוח בקרה",
  // Hebrew
  unknown: "לא ידוע",
  noData: "אין נתונים",
  noInvoicesToExport: "אין חשבוניות לייצוא",
  invoiceNumber: "מספר חשבונית",
  vendorName: "שם הספק",
  businessNumber: "מספר עסק",
  invoiceDate: "תאריך חשבונית",
  place: "מקום",
  subTotal: "סכום ביניים",
  taxRate: "שיעור מס",
  taxAmount: "סכום מס",
  totalAmount: "סכום כולל",
  totals: "סיכומים",
  success: "הצלחה",
  exportedSuccessfully: "יוצא בהצלחה",
  error: "שגיאה",
  exportFailed: "הייצוא נכשל",
  invoices: "חשבוניות",
  date: "תאריך",
  tax: "מס",
  generatedBy: "נוצר על ידי",
  printDialogOpened: "תיבת דו-שיח הדפסה נפתחה. בחר 'שמור כ-PDF' לשמירה.",
  amount: "סכום",
  withInvoice: "עם חשבונית",
  yes: "כן",
  no: "לא",
  note: "הערה",
  invoiceDetails: "פרטי חשבונית",
  expenseDetails: "פרטי הוצאה",
  expensesAndInvoices: "הוצאות וחשבוניות",
  totalExpenses: "סך ההוצאות",
  items: "פריטים",
  outOf: "מתוך",
  noInvoice: "אין חשבונית",
  needsAttention: "דורש תשומת לב",
  totalSubTotal: "סך הכל סכום ביניים",
  totalTax: "סך המס",
  fromInvoices: "מחשבוניות",
  totalInvoices: "סך החשבוניות",
  expenses: "הוצאות",
  searchInvoices: "חיפוש חשבוניות...",
  cancel: "ביטול",
  select: "בחר",
  deselectAll: "בטל בחירת הכל",
  selectAll: "בחר הכל",
  export: "ייצא",
  exportAll: "ייצא הכל",
  noExpensesFound: "לא נמצאו הוצאות",
  expensesWillAppearHere: "הוצאות יופיעו כאן",
  noSearchResults: "אין תוצאות חיפוש",
  noInvoicesFound: "לא נמצאו חשבוניות",
  tryDifferentSearch: "נסה מונח חיפוש אחר",
  invoicesWillAppearHere: "חשבוניות יופיעו כאן",
  ok: "אישור",
  exportOptions: "אפשרויות ייצוא",
  chooseExportFormat: "בחר פורמט ייצוא",
  excelDescription: "ייצוא כגיליון אלקטרוני לניתוח נתונים",
  pdfDescription: "ייצוא כמסמך מעוצב להדפסה",
  total: 'סה"כ',
  place: "מקום",
  me: "אני",
  sunday: "ראשון",
  monday: "שני",
  tuesday: "שלישי",
  wednesday: "רביעי",
  thursday: "חמישי",
  friday: "שישי",
  saturday: "שבת",
  workSlip: "תלוש עבודה",
  contractor: "קבלן",
  employeeName: "שם העובד",
  salaryType: "סוג משכורת",
  monthlySalary: "משכורת חודשית",
  dailySalary: "שכר יומי",
  employeeInformation: "מידע על העובד",
  summary: "סיכום",
  workingDays: "ימי עבודה",
  totalSalaryMonth: 'סה"כ משכורת (חודש)',
  avgPerDay: "ממוצע ליום",
  avgDaily: "ממוצע יומי",
  workDays: "ימי עבודה",
  day: "יום",
  dayName: "שם היום",
  salary: "משכורת",
  manager: "מנהל",
  notes: "הערות",
  worked: "עבד",
  noWorkDataForMonth: "אין נתוני עבודה לחודש זה",
  generatedOn: "נוצר ב",
  selectMonth: "בחר חודש",
  excelExportedSuccessfully: "Excel יוצא בהצלחה",
  failedToExportExcel: "ייצוא Excel נכשל",
  pleaseSelectMonth: "אנא בחר חודש תחילה",
  exportWorkSlip: "ייצא תלוש עבודה",
  chooseExportFormat: "בחר פורמט ייצוא",
  excelDescription: "ייצוא כגיליון אלקטרוני לניתוח נתונים",
  pdfDescription: "ייצוא כמסמך מעוצב להדפסה",
  monthly: "חודשי",
  daily: "יומי",
  monthly: "חודשי",
  daily: "יומי",
  manager: "מנהל",
  employee: "עובד",
  employees: "עובדים",
  managers: "מנהלים",
  id: "מזהה",
  contractor: "קבלן",
  searchByName: "חיפוש לפי שם...",
  noEmployeesMatchSearch: "אין עובדים התואמים לחיפוש שלך",
  noEmployeesFound: "לא נמצאו עובדים",
  tryDifferentSearch: "נסה מונח חיפוש אחר",
  pullDownToRefresh: "משוך למטה לרענון",
  failedToLoadContractors: "נכשל בטעינת הקבלנים",
  phoneNumberNotAvailable: "מספר טלפון לא זמין",
  emailNotAvailable: 'דוא"ל לא זמין',
  active: "פעיל",
  noContactInfo: "אין פרטי קשר",
  id: "מזהה",
  loadingContractors: "טוען קבלנים...",
  myContractors: "הקבלנים שלי",
  contractors: "קבלנים",
  inviteContractor: "הזמן קבלן",
  activeContractors: "קבלנים פעילים",
  noContractorsFound: "לא נמצאו קבלנים",
  contractorsWillAppearHere: "קבלנים יופיעו כאן",
  settings: "הגדרות",
  manageYourPreferences: "נהל את ההעדפות שלך",
  language: "שפה",
  change: "שנה",
  selectLanguage: "בחר שפה",
  chooseYourPreferredLanguage: "בחר את השפה המועדפת עליך",

  // Language names
  languageEnglish: "אנגלית",
  languageArabic: "ערבית",
  languageHebrew: "עברית",
  Contact: "צור קשר",
  GetInTouch: "צור קשר",
  ContactDescription: "יש לך שאלות? אנחנו כאן לעזור!",
  WhatsApp: "וואטסאפ",
  ChatWithUs: "שוחח איתנו",
  Phone: "טלפון",
  CallUs: "התקשר אלינו ישירות",
  SMS: "הודעת טקסט",
  TextUs: "שלח לנו הודעה",
  ContactAvailability: "זמינים 24/7 לסייע לך",
  // Navigation
  Features: "תכונות",
  MobileApp: "אפליקציה",
  Benefits: "יתרונות",
  GetStarted: "התחל עכשיו",

  // Hero Section
  TrustedByProfessionals: "🚀 מהימן על ידי למעלה מ-10,000 אנשי מקצוע",
  AppointmentManagement: "ניהול תורים,",
  Simplified: "פשוט",
  HeroDescription:
    "המר את הכאוס בתזמון שלך לפעולות חלקות. נהול תורם מביא יחד כלי הזמנה חזקים, ניהול לקוחות וניתוח בפלטפורמה אחת יפה.",
  StartFreeTrial: "התחל תקופת ניסיון חינמית",
  WatchDemo: "צפה בהדגמה",

  // Stats
  ActiveUsers: "משתמשים פעילים",
  AppointmentsBooked: "תורים שנקבעו",
  Uptime: "זמן פעילות",
  UserRating: "דירוג משתמשים",

  // Features Section
  EverythingYouNeedTo: "כל מה שאתה צריך",
  Succeed: "להצליח",
  BuiltForProfessionals: "נבנה עבור אנשי מקצוע שדורשים מצוינות בכל פרט",

  SmartScheduling: "תזמון חכם",
  SmartSchedulingDesc:
    "ניהול תורים חכם שמתאים לזרימת העבודה שלך ומבטל הזמנות כפולות",
  SmartSchedulingStat: "דיוק של 99.8%",

  ClientManagement: "ניהול לקוחות",
  ClientManagementDesc:
    "פרופילי לקוחות מקיפים עם היסטוריה, העדפות ותקשורת אוטומטית",
  ClientManagementStat: "חיסכון של 50% בזמן",

  AnalyticsInsights: "ניתוחים ותובנות",
  AnalyticsInsightsDesc:
    "סטטיסטיקות בזמן אמת וניתוחים חזוייתיים לשיפור ביצועי העסק שלך",
  AnalyticsInsightsStat: "צמיחה פי 3",

  // Mobile App Section
  AvailableOnMobile: "זמין במובייל",
  ManageEverything: "נהל הכל",
  OnTheGo: "בדרכים",
  MobileAppDescription: "הורד את אפליקציית נהול תורם ושלוט בתורים שלך מכל מקום",

  YourBusinessInYourPocket: "העסק שלך בכיס",
  MobileAppFullDescription:
    "אפליקציית נהול תורם נותנת לך שליטה מלאה על התורים, הלקוחות והניתוחים העסקיים שלך - ישירות מהסמארטפון שלך.",

  RealTimeSync: "סנכרון בזמן אמת",
  RealTimeSyncDesc: "עדכונים מיידיים בכל המכשירים שלך",

  PushNotifications: "התראות דחיפה",
  PushNotificationsDesc: "אל תפספס אף תור או הודעה",

  WorksOffline: "עובד במצב לא מקוון",
  WorksOfflineDesc: "גישה לנתונים שלך גם ללא אינטרנט",

  DownloadNow: "הורד עכשיו",
  GetItOnGooglePlay: "הורד ב",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "הורד ב",
  AppStore: "App Store",

  FreeToDownload: "✨ הורדה חינמית • זמין ברחבי העולם • עדכונים קבועים",

  SeeItInAction: "ראה את זה בפעולה",

  // Benefits Section
  WhyProfessionalsChoose: "למה אנשי מקצוע בוחרים ב",
  NeholEsek: "נהול תורם",
  BenefitsDescription:
    "הצטרף לאלפי עסקים ששינו את הפעילות שלהם עם ניהול תורים חכם.",

  SaveHoursDaily: "חסוך שעות מדי יום",
  SaveHoursDesc: "הפוך משימות חוזרות לאוטומטיות והתמקד במה שחשוב",

  NeverMissAppointment: "לעולם אל תפספס תור",
  NeverMissDesc: "תזכורות אוטומטיות והתראות חכמות",

  InstantSetup: "התקנה מיידית",
  InstantSetupDesc: "התחל תוך פחות מ-5 דקות",

  BoostRevenue: "הגדל הכנסות",
  BoostRevenueDesc: "הפחת אי הגעה ב-67% עם תזכורות חכמות",

  TodaysAppointments: "תורים להיום",
  ClientSatisfaction: "שביעות רצון לקוחות",
  ThisMonthRevenue: "הכנסות החודש",
  PercentageFromLastMonth: "+23% מהחודש שעבר",
  ActiveClients: "לקוחות פעילים",
  ShowRate: "אחוז הגעה",

  // CTA Section
  ReadyToTransform: "מוכן לשנות את העסק שלך?",
  CTADescription:
    "הצטרף ליותר מ-10,000 אנשי מקצוע שסומכים על נהול תורם לצרכי התזמון שלהם",
  DownloadApp: "הורד אפליקציה",
  FreeTrial:
    "לא נדרש כרטיס אשראי • תקופת ניסיון חינמית ל-45 יום • ביטול בכל עת",

  // Footer
  Privacy: "פרטיות",
  Terms: "תנאים",
  Contact: "צור קשר",
  CopyrightMainPage: "© 2024 נהול תורם. כל הזכויות שמורות.",
  CustomerReviews: "ביקורות לקוחות",
  SeeWhatOurCustomersSay: "ראה מה הלקוחות שלנו אומרים עלינו",
  OutOf: "מתוך",
  Reviews: "ביקורות",
  NoComment: "לא סופק תגובה",
  myappointments: "הפגישות שלי",
  TheMainPage: "עמוד ראשי",
  Gallery: "גלריה",
  ContactInfo: "פרטי קשר",
  Chooselanguage: "בחר שפה",
  Home: "בית",
  MyAppointments: "התורים שלי",
  Loading: "טוען...",
  BookYourAppointment: "קבע תור",
  ChoosePreferredDateTime: "בחר תאריך ושעה מועדפים",
  OnlineBookingComingSoon: "הזמנה מקוונת בקרוב",
  BarberStopDescription:
    "BarberStop מאפשר לתזמן תורים דרך האפליקציה! כרגע, תכונה זו נמצאת בהכנה.",
  InTheMeantime: "בינתיים, קבע את התור שלך דרך:",
  SMS: "הודעת טקסט",
  PhoneCall: "שיחת טלפון",
  WhatsApp: "וואטסאפ",
  Tip: "טיפ:",
  MentionBarberStop: 'הזכר את "BarberStop" כשאתה יוצר קשר!',
  ModernBookingSolutions: "פתרונות הזמנה מודרניים",
  Copyright: "© 2025 NeholEsek. כל הזכויות שמורות.",

  // New Business Owner translations
  ForBusinessOwners: "לבעלי עסקים",
  WantYourOwnBusinessApp: "רוצה עסק משלך?",
  DownloadNeholEsekForBusinessOwners:
    "הורד את נהול תורם והתחל לנהל את מספרת שלך היום!",
  Business: "עסקי",
  WhatsIncluded: "מה כלול:",
  ManageAppointments: "ניהול תורים באינטרנט",
  TrackCustomers: "מעקב אחר הלקוחות שלך",
  IncreaseRevenue: "הגדל את ההכנסות שלך",
  BusinessAnalytics: "ניתוח ודוחות עסקיים",
  JoinThousandsOfBarbers: "הצטרף לאלפי ספרים המנהלים את העסק שלהם עם נהול תורם",
  DownloadOnThe: "הורד ב",
  GetItOn: "הורד ב",

  // MPHomeApps translations
  PleaseLoginToView: "אנא התחבר כדי לצפות בתורים שלך",
  SignInToAccess: "התחבר כדי לגשת להיסטוריית התורים ולנהל הזמנות",
  ManageYourBookings: "נהל את ההזמנות הקרובות שלך",
  LoadingYourAppointments: "טוען את התורים שלך...",
  User: "משתמש",
  Logout: "התנתק",
  NoAppointmentsYet: "אין תורים עדיין",
  BookYourFirst: "קבע את התור הראשון שלך כדי להתחיל עם השירותים שלנו",
  TodaysAppointment: "התור של היום",
  Past: "עבר",
  Min: "דקות",
  Services: "שירותים",
  Total: "סה״כ",
  Barber: "ספר:",
  CancelAppointment: "בטל תור",
  CancelAppointmentQuestion: "לבטל את התור?",
  CancelConfirmation:
    "האם אתה בטוח שברצונך לבטל את התור הזה? לא ניתן לבטל פעולה זו.",
  KeepIt: "שמור אותו",
  YesCancel: "כן, בטל",

  // MPHomeBookApp translations
  Login: "התחבר",
  BarberStep: "ספר",
  ServicesStep: "שירותים",
  Book: "הזמן",
  ChooseYourBarber: "בחר את הספר שלך",
  SelectBarberForAppointment: "בחר ספר לתור שלך",
  ProfessionalBarber: "ספר מקצועי",
  SelectABarber: "בחר ספר",
  ChoosePreferredBarber: "בחר את הספר המועדף עליך כדי להמשיך",
  NextSelectServices: "הבא: בחר שירותים ←",
  YourBarber: "הספר שלך",
  Change: "שנה",
  SelectYourServices: "בחר את השירותים שלך",
  ChooseOneOrMoreServices: "בחר שירות אחד או יותר לתור שלך",
  TotalDuration: "משך זמן כולל",
  TotalPrice: "מחיר כולל",
  SelectAtLeastOneService: "בחר לפחות שירות אחד",
  ChooseFromServices: "בחר מהשירותים שלמעלה כדי להמשיך",
  NextSelectDateTime: "הבא: בחר תאריך ושעה ←",
  SelectedServices: "שירותים שנבחרו",
  Edit: "ערוך",
  SelectDate: "בחר תאריך",
  Today: "היום",
  AvailableTimes: "זמנים זמינים",
  TotalDurationNeeded: "משך זמן כולל נדרש:",
  Minutes: "דקות",
  ShowingConsecutiveSlots: "מציג זמנים עם מספיק משבצות רצופות",
  NoAvailableAppointments: "אין תורים זמינים",
  NoConsecutiveSlotsFound:
    "לא נמצאו משבצות רצופות עם {duration} דקות זמינות. נסה לבחור תאריך אחר או פחות שירותים.",
  PleaseSelectAnotherDate: "אנא בחר תאריך אחר",
  BackToServices: "→ חזור לשירותים",

  // MPHomeLoginWithPhoneNumber translations
  Phone: "טלפון",
  Verify: "אמת",
  Name: "שם",
  Welcome: "ברוך הבא! 👋",
  EnterPhoneToGetStarted: "הזן את מספר הטלפון שלך כדי להתחיל",
  PhoneNumber: "מספר טלפון",
  FullNumber: "מספר מלא:",
  Sending: "שולח...",
  SendVerificationCode: "שלח קוד אימות",
  VerifyYourNumber: "אמת את המספר שלך 🔐",
  WeSentCodeTo: "שלחנו קוד ל",
  VerificationCode: "קוד אימות",
  EnterSixDigitCode: "הזן קוד בן 6 ספרות",
  Verifying: "מאמת...",
  VerifyCode: "אמת קוד",
  ChangePhoneNumber: "→ שנה מספר טלפון",
  AlmostThere: "כמעט סיימנו! ✨",
  EnterNameToComplete: "אנא הזן את שמך להשלמת ההרשמה",
  YourName: "השם שלך",
  EnterFullName: "הזן את שמך המלא",
  Completing: "משלים...",
  CompleteRegistration: "השלם הרשמה",
  PleaseEnterValidPhone: "אנא הזן מספר טלפון תקין",
  OTPSentTo: "קוד אימות נשלח ל",
  ErrorMessage: "שגיאה:",
  PhoneVerifiedSuccessfully: "הטלפון אומת בהצלחה!",
  PleaseEnterValidOTP: "אנא הזן קוד תקין בן 6 ספרות",
  InvalidOTP: "קוד לא תקין. נסה שוב.",
  PleaseEnterYourName: "אנא הזן את שמך",
  LoginSuccessful: "התחברות הצליחה!",
  FailedToSaveUser: "שמירת המשתמש נכשלה:",

  // MPHomeModalMakeApp translations
  ConfirmYourBooking: "אשר את ההזמנה שלך",
  ReviewAppointmentDetails: "סקור את פרטי התור שלך למטה",
  YourInformation: "המידע שלך",
  Guest: "אורח",
  NotAvailable: "לא זמין",
  BarberDetails: "פרטי הספר",
  AppointmentDetails: "פרטי התור",
  Date: "תאריך",
  Time: "שעה",
  Duration: "משך",
  SelectedServicesUpper: "שירותים שנבחרו",
  Cancel: "ביטול",
  BookingInProgress: "מזמין...",
  ConfirmBooking: "אשר הזמנה",
  ConfirmationMessage: "הודעת אישור",
  WhatsAppConfirmation: "תקבל הודעת אישור בוואטסאפ בקרוב",

  // Contractor Landing Page
  signIn: "כניסה",
  demo: "הדגמה",
  pricing: "תמחור",
  availableOnMobileWeb: "📱 זמין במובייל ובאינטרנט",
  heroTitleContractor: "נהל את עסק הבנייה שלך כמו",
  heroPro: "מקצוען",
  heroDescriptionContractor:
    "פתרון מקיף לניהול כוח אדם לקבלנים. עקוב אחר עובדים, נהל משכורות, עקוב אחר רווחים ושלוט בהוצאות - הכל בפלטפורמה אחת עוצמתית.",
  getStartedFree: "התחל בחינם",
  noCreditCardRequired: "לא נדרש כרטיס אשראי",
  fortyFiveDayFreeTrial: "ניסיון חינמי 45 יום",
  todaysOverview: "סקירת היום",
  liveLabel: "חי",
  activeEmployees: "עובדים פעילים",
  monthlyProfit: "רווח חודשי",
  activeSites: "אתרים פעילים",
  growthRate: "שיעור צמיחה",
  revenueVsExpenses: "הכנסות מול הוצאות",
  everythingYouNeedToSucceed: "כל מה שאתה צריך כדי להצליח",
  powerfulFeaturesForContractors:
    "תכונות עוצמתיות שתוכננו עבור קבלנים מודרניים",
  featureEmployeeManagement: "ניהול עובדים",
  featureEmployeeManagementDesc:
    "עקוב אחר נוכחות יומית, שעות עבודה והקצה עובדים לאתרי עבודה ספציפיים בקלות",
  featureSalaryPayroll: "שכר ומשכורות",
  featureSalaryPayrollDesc:
    "חישובי שכר אוטומטיים על בסיס ימי עבודה ושעות עם רשומות תשלום מפורטות",
  featureProfitAnalytics: "ניתוח רווחים",
  featureProfitAnalyticsDesc:
    "מעקב רווחים בזמן אמת עם דוחות פיננסיים מקיפים וניהול הוצאות",
  featureRoleBasedAccess: "גישה מבוססת תפקיד",
  featureRoleBasedAccessDesc:
    "מערכת היררכית: קבלן ← מנהלים ← משתמשים עם הרשאות הניתנות להתאמה אישית",
  featureJobSiteTracking: "מעקב אתר עבודה",
  featureJobSiteTrackingDesc:
    "צור ונהל מקומות עבודה מרובים, הקצה צוותים ועקוב אחר ההתקדמות מדי יום",
  featureExpenseControl: "שליטה בהוצאות",
  featureExpenseControlDesc:
    "עקוב אחר כל הוצאות הפרויקט עם זרימות עבודה לאישור ומעקב תקציב",
  hierarchicalAccessControl: "בקרת גישה היררכית",
  completeControlWhoSeesWhat: "שליטה מלאה על מי רואה מה",
  fullAccessToEverything: "גישה מלאה לכל הדברים",
  createWorkplaces: "יצירת מקומות עבודה",
  manageAllEmployees: "ניהול כל העובדים",
  createManagerAccounts: "יצירת חשבונות מנהלים",
  setPermissionsAccess: "הגדרת הרשאות וגישה",
  viewAllFinancialData: "צפייה בכל הנתונים הפיננסיים",
  assignedSiteAccess: "גישה לאתרים מוקצים",
  accessAssignedSites: "גישה לאתרים מוקצים",
  enterDailyAttendance: "הכנסת נוכחות יומית",
  createUserAccounts: "יצירת חשבונות משתמשים",
  submitExpensesIfAllowed: "הגשת הוצאות (אם מותר)",
  viewPermittedData: "צפייה בנתונים מורשים",
  limitedAccess: "גישה מוגבלת",
  viewAssignedTasks: "צפייה במשימות מוקצות",
  checkInOutOfSites: "כניסה/יציאה מאתרים",
  viewOwnWorkHistory: "צפייה בהיסטוריית עבודה אישית",
  accessBasicReports: "גישה לדוחות בסיסיים",
  submitTimesheets: "הגשת דוחות שעות",
  realTimeDataVisualization: "ויזואליזציה וניהול נתונים בזמן אמת",
  daysWorked: "ימי עבודה",
  statusLabel: "סטטוס",
  jobSitePerformance: "ביצועי אתר עבודה",
  siteName: "שם האתר",
  revenueLabel: "הכנסות",
  profitLabel: "רווח",
  powerfulAnalyticsDashboard: "לוח ניתוח נתונים עוצמתי",
  trackBusinessPerformance: "עקוב אחר ביצועי העסק שלך עם ויזואליזציות יפות",
  totalRevenue: "סך ההכנסות",
  netProfit: "רווח נקי",
  activeProjects: "פרויקטים פעילים",
  last6Months: "6 חודשים אחרונים",
  expenseBreakdown: "פירוט הוצאות",
  projectCompletion: "השלמת פרויקט",
  performanceMetrics: "מדדי ביצועים",
  efficiencyRate: "שיעור יעילות",
  onTimeDelivery: "אספקה בזמן",
  ctaDescriptionContractors:
    "הצטרף למאות קבלנים שייעלו את פעילותם עם ContractorPro",
  scheduleDemo: "תזמן הדגמה",
  noCreditCardFreeTrialCancel:
    "לא נדרש כרטיס אשראי • ניסיון חינמי 45 יום • ביטול בכל עת",
  footerDescription: "הפתרון המלא לקבלנים מודרניים לניהול כוח אדם ופיננסים.",
  footerProduct: "מוצר",
  footerCompany: "חברה",
  footerLegal: "משפטי",
  aboutUs: "אודותינו",
  careers: "קריירה",
  blog: "בלוג",
  privacyPolicy: "מדיניות פרטיות",
  termsOfService: "תנאי שירות",
  securityLabel: "אבטחה",
  faq: "שאלות נפוצות",

  // BossMainPage Navigation
  places: "מקומות",
  general: "כללי",
  calc: "מחשבון",
  createInvoice: "צור חשבונית",
  createOffer: "יצור הצעה",

  ownerAccount: "חשבון בעלים",
  workforce: "כוח אדם",
  myEmployees: "העובדים שלי",
  contactUs: "צור קשר",
  accountant: "רואה חשבון",
  deleteAccount: "מחק חשבון",

  // Calculator
  projectCalculator: "מחשבון פרויקט",
  smallProject: "פרויקט קטן",
  bigProject: "פרויקט גדול",
  oneTimeFixedPriceEstimate: "הערכת מחיר קבוע חד פעמית",
  monthByMonthBilling: "חיוב חודשי לפי התקדמות",

  // Employee Management
  createEmployee: "צור עובד",
  createNewEmployee: "צור עובד חדש",
  addNewTeamMember: "הוסף חבר צוות חדש",
  updateEmployee: "עדכן עובד",
  updateProfile: "עדכן פרופיל",
  employeeType: "סוג עובד",
  employeeId: "מזהה עובד",
  employeeStatus: "סטטוס עובד",
  inactive: "לא פעיל",
  inactiveEmployees: "עובדים לא פעילים",
  inactivePlaces: "מקומות לא פעילים",
  noInactiveEmployees: "אין עובדים לא פעילים",
  noInactivePlaces: "אין מקומות לא פעילים",
  allEmployeesActive: "כל העובדים פעילים כרגע",
  allPlacesActive: "כל המקומות פעילים",
  noEmployeesYet: "אין עובדים עדיין",
  tapButtonToAddFirstMember: "לחץ על כפתור + להוספת חבר הצוות הראשון שלך.",
  nothingMatchesSearch: "אין תוצאות לחיפוש שלך. נסה מונח אחר.",
  employeeTypeDesc: "לעובדים יש גישה סטנדרטית למשימות ולאזורי העבודה שלהם.",
  managerTypeDesc:
    "למנהלים יש הרשאות מוגבהות הכוללות פיקוח על הצוות ויכולות דיווח.",

  // Place Management
  createPlace: "צור מקום",
  createNewPlace: "צור מקום חדש",
  workplaceName: "שם מקום העבודה",
  enterWorkplaceName: "הזן שם מקום עבודה",
  paymentMethod: "שיטת תשלום",
  globalProfitLabel: "רווח כולל",
  enterGlobalProfit: "הזן רווח כולל",
  monthlyProfitLabel: "רווח חודשי",
  dailySalaryPerEmployee: "שכר יומי לעובד",
  enterDailySalaryPerEmployee: "הזן שכר יומי לעובד",
  enterProfitAmount: "הזן סכום רווח",
  monthlyPaymentDesc:
    "תשלום חודשי: רווח קבוע נצבר כל חודש ללא קשר למספר ימי העבודה.",
  dailyPaymentDesc:
    "תשלום יומי: ההכנסות נמדדות לפי יום עבודה בהתבסס על התעריף היומי שנקבע למקום זה.",
  globalPaymentDesc:
    "תשלום כולל: סכום רווח כולל חד-פעמי מוסכם לכל משך הפרויקט.",
  monthlyProfitInfo: "הרווח החודשי יירשם כהכנסה עבור מקום זה בכל חודש.",
  dailySalaryRateInfo: "כל יום עבודה יייצר הכנסה בהתבסס על תעריף השכר היומי.",
  globalProfitInfo: "הרווח הכולל מייצג את סכום החוזה הכולל לכל משך הפרויקט.",
  optional: "אופציונלי",
  canUpdateLater: "ניתן לשנות או לעדכן זאת מאוחר יותר",

  // Form Fields
  enterEmployeeName: "הזן שם עובד",
  enterPassword: "הזן סיסמה",
  enterNewPasswordOptional: "הזן סיסמה חדשה (אופציונלי)",
  leaveBlankToKeepPassword: "השאר ריק לשמירת הסיסמה הנוכחית",
  cannotBeChanged: "לא ניתן לשינוי",
  searchByNamePlaceholder: "חיפוש לפי שם...",

  // Salary Type Info
  dailySalaryTypeInfo: "השכר היומי יחול על כל יום עבודה.",
  monthlySalaryTypeInfo: "המשכורת החודשית תשולם פעם בחודש ללא קשר לימי העבודה.",

  // Permissions
  expensesAccess: "גישה להוצאות",
  hasAccess: "יש גישה",
  noAccess: "אין גישה",
  placeAccess: "גישה למקום",
  noPlacesAvailable: "אין מקומות זמינים",
  placesSelected: "מקומות נבחרו",

  // Success Messages
  employeeCreatedSuccessfully: "העובד נוצר בהצלחה!",
  employeeActivatedSuccessfully: "העובד הופעל בהצלחה!",
  employeeUpdatedSuccessfully: "העובד עודכן בהצלחה!",
  profileUpdatedSuccessfully: "הפרופיל עודכן בהצלחה!",
  placeCreatedSuccessfully: "המקום נוצר בהצלחה!",
  placeActivatedSuccessfully: "המקום הופעל בהצלחה!",

  // Error Messages
  failedToActivatePlace: "נכשל בהפעלת המקום",
  failedToActivateEmployee: "נכשל בהפעלת העובד",
  failedToCreateEmployee: "נכשל ביצירת עובד",
  failedToUpdateProfile: "נכשל בעדכון הפרופיל. אנא נסה שוב.",
  employeeNameAlreadyTaken: "שם העובד כבר תפוס",
  nameAlreadyTaken: "שם זה כבר תפוס. אנא בחר שם אחר.",
  failedToCreatePlace: "נכשל ביצירת מקום",
  employeeNameRequired: "שם העובד נדרש",
  placeNameRequired: "שם המקום נדרש",
  dailySalaryRequired: "שכר יומי נדרש",
  globalProfitRequired: "רווח כולל נדרש",
  enterValidDailySalary: "אנא הזן שכר יומי תקין",
  enterValidMonthlySalary: "אנא הזן משכורת חודשית תקינה",
  passwordRequired: "סיסמה נדרשת",
  passwordMinLength: "הסיסמה חייבת להכיל לפחות 4 תווים",
  pleaseEnterEmployeeName: "אנא הזן שם עובד",
  pleaseEnterPassword: "אנא הזן סיסמה",
  nameRequired: "שם נדרש",
  userDataNotFound: "נתוני משתמש לא נמצאו",

  // Confirmation Dialogs
  confirmLogout: "האם אתה בטוח שברצונך להתנתק?",
  confirmDeleteAccount: "האם אתה בטוח שברצונך למחוק את חשבונך?",
  deleteAccountMessage: "לא ניתן לבטל פעולה זו.",
  confirmActivateEmployee: "האם אתה בטוח שברצונך להפעיל עובד זה?",
  confirmActivatePlace: "להפעיל מקום זה?",

  // Subscription
  subscriptionExpired: "המנוי פג תוקף",
  subscriptionExpiredMessage:
    "המנוי שלך פג תוקף. אנא חדש כדי להמשיך להשתמש בשירות.",
  subscriptionExpiringToday: "המנוי פג היום",
  subscriptionExpiringTodayMessage:
    "המנוי שלך פג היום. אנא חדש כדי למנוע הפסקת שירות.",
  subscriptionExpiringSoon: "המנוי פג בקרוב",
  contactToRenew: "צור קשר לחידוש",
  contactUsToRenew: "צור קשר לחידוש:",
  weAreAvailable247: "אנחנו זמינים 24/7 לעזור לך לחדש את המנוי",
  helloSubscriptionExpired: "שלום, המנוי שלי פג תוקף. אני רוצה לחדש אותו.",
  helloSubscriptionExpiresToday: "שלום, המנוי שלי פג היום. אני רוצה לחדש אותו.",
  helloSubscriptionExpiresSoon: "שלום, המנוי שלי פג בקרוב. אני רוצה לחדש אותו.",
  helloInquire: "שלום, אני רוצה לברר על השירות.",

  // Statistics
  statistics: "סטטיסטיקות",
  totalSalaries: 'סה"כ משכורות',
  totalDailyRevenue: "סך ההכנסות היומיות שנגבו",
  receivedFromGlobalProfit: "התקבל מסך הרווח הכולל",
  monthlyProfitFromPlace: "רווח חודשי ממקום",
  totalPaidToDailyEmployees: "סך שולם לעובדים יומיים",
  totalExpensesThisMonth: "סך ההוצאות החודש",
  netProfitLabel: "רווח נקי",
  revenueMinus: "הכנסות פחות עלויות והוצאות",
  dailyOperations: "פעולות יומיות",
  placePerformance: "ביצועי מקום",
  financialBreakdown: "פירוט פיננסי",
  extraProfitLabel: "רווח נוסף",
  extraProfitDesc: "רווח נוסף מעבודה נוספת",
  extraProfitsReceived: "רווחים נוספים שהתקבלו",
  monthlyEmployeesPaid: "עובדים חודשיים",
  paid: "שולם",
  paymentsReceived: "תשלומים שהתקבלו",
  noActivity: "אין פעילות",
  noDataThisMonth: "אין נתונים החודש",
  selectDifferentMonth: "בחר חודש אחר",

  // Expense Types
  materials: "חומרים",
  equipment: "ציוד",
  transportation: "תחבורה",
  utilities: "שירותים",
  otherExpense: "אחר",

  // Actions
  creating: "יוצר...",
  updating: "מעדכן...",
  activating: "מפעיל...",
  refreshing: "מרענן...",
  addPayment: "הוסף תשלום",
  addExtra: "הוסף תוספת",
  callUs: "התקשר אלינו",
  chatOnWhatsApp: "שוחח בוואטסאפ",
  sendEmail: 'שלח דוא"ל',
  talkDirectly: "דבר איתנו ישירות",
  quickResponse: "תגובה מהירה",
  sendMessage: "שלח לנו הודעה",

  // Language Settings
  chooseYourLanguage: "בחר את שפתך",
  selectPreferredLanguage: "בחר את השפה המועדפת עליך",

  // Invoice
  createNewInvoice: "צור חשבונית חדשה",
  noResultsFound2: "לא נמצאו תוצאות",

  // CreateInvoice
  offer: "הצעת מחיר",
  billTo: "לחיוב",
  thankYou: "תודה על עסקתכם",
  printSaveAsPdf: "הדפס / שמור כ-PDF",
  createdBy: "נוצר על ידי",
  yourNameBusiness: "שמך / העסק שלך",
  yourNameOrCompany: "שמך או שם החברה",
  clientNameLabel: "שם הלקוח",
  clientNamePlaceholder: "שם הלקוח / החברה",
  clientEmailLabel: 'דוא"ל הלקוח',
  addressLabel: "כתובת",
  streetAddress: "כתובת רחוב",
  cityCountry: "עיר / מדינה",
  unpaid: "לא שולם",
  invoiceNumberLabel: "מספר חשבונית",
  issueDate: "תאריך הנפקה",
  dueDate: "תאריך פירעון",
  description: "תיאור",
  qty: "כמות",
  rate: "מחיר",
  addLineItem: "+ הוסף שורה",
  serviceDescription: "תיאור השירות",
  notesPlaceholder: "פרטי בנק, הוראות תשלום, או הודעת תודה...",
  offerTitle: "כותרת ההצעה",
  offerTitlePlaceholder: "לדוגמה: פרויקט עיצוב אתר",
  preparedFor: "מוגש עבור",
  validUntil: "בתוקף עד",
  includeTaxInTotal: 'כלול מס בסה"כ',

  // Place Statistics
  searchByPlaceName: "חפש לפי שם מקום...",
  noPlacesMatchSearch: "אין מקומות התואמים לחיפוש שלך",
  noPlacesYet: "אין מקומות עדיין",
  addPlacesToTrack: "הוסף מקומות כדי להתחיל לעקוב אחר הביצועים",
  addPlace: "הוסף מקום",
  global: "כולל",
  extraProfit: "רווח נוסף",
  invoiceCosts: "עלויות חשבוניות",
  monthlyEmployees: "עובדים חודשיים",
  dailySalaries: "שכר יומי",
  newInvoice: "חשבונית חדשה",
  expense: "הוצאה",
  edit: "ערוך",
  delete: "מחק",
  dailyRevenueCollected: "הכנסות יומיות שנגבו",
  monthlyPlaceProfit: "רווח חודשי ממקום",
  additionalWorkIncome: "הכנסה מעבודה נוספת",
  fixedMonthlySalaries: "משכורות חודשיות קבועות",
  paidToDailyEmployees: "שולם לעובדים יומיים",
  revenueMinusCosts: "הכנסות פחות עלויות",
  receivedMinusAllCosts: "שתקבל פחות כל העלויות",
  profitMinusCosts: "רווח פחות עלויות",
  tapToAdd: "לחץ להוספה",
  manageInvoices: "נהל חשבוניות",
  linkInvoices: "קשר חשבוניות",
  noInvoicesLinkedYet: "אין חשבוניות מקושרות עדיין",
  totalIlsEquivalent: 'סה"כ (שווה ₪)',
  rateUnavailable: "שער לא זמין — משתמש בערך נקוב",
  rateLookupFailed: "חיפוש שער נכשל",
  analytics: "ניתוחים",
  dailyBreakdown: "פירוט יומי",
  costs: "עלויות",
  days: "ימים",
};

const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
  he: {
    translation: he,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
